export default {
  auth: {
    unauthenticated: 'Your session has expired. Please log in again.'
  },
  acl: {
    load_error: 'Error loading the access rights.'
  },
  headMenue: {
    customer: 'Customer',
    fmv: 'FMV',
    courses: 'Courses',
    ls: 'Academy',
    kifam: 'Family',
    schedtools: 'Scheduling tool',
    tickets: 'Ticket',
    campaigns: 'Campaigns',
    search: 'Search',
  },
  tabs: {
    course_participation: 'Course participation',
    course_information: 'Course information',
    service_contribution: 'Service/Contribution',
    course_basic_data: 'Course title',
    course_general_data: 'General settings',
    course_master_data: 'Master data',
    course_dates: 'Dates',
    lecturer_days: 'Lecturer days',
    teacher_days: 'Teaching days',
    subscriber: 'Participants',
    course_documents: 'Course documents',
    invoice: 'Billing',
    benefits: 'Benefits',
    person: 'Person',
    company: 'Company',
    contact: 'Contact',
    documents: 'Documents',
    action: 'Action',
  },
  contact: {
    in_title: 'Contact IN',
    out_title: 'Contact OUT',
    campaign_title: 'Campaign action',
    ticket_history_title: 'Ticket contact history',
    medium: 'Medium',
    subject: 'Subject',
    result: 'Result',
    campaign_status: 'Campaign status',
    campaign: 'Campaign',
    message: 'Message',
    to: 'To',
    request: 'Request',
    status: 'Status'
  },
  relations: {
    title: 'Customer relation',
    start: 'Start',
    purpose: 'Purpose',
    payment_method: 'Payment',
    payment_status: 'Relation status',
    customer_number: 'Customer no.',
    phone: 'Phone',
    letter: 'Letter'
  },
  payments: {
    title: 'Payment history',
    title_participant: 'Participant payment history',
    relation: 'Linked relation',
    purpose: 'Purpose',
    notice: 'Note',
    maturity: 'Maturity',
    status: 'Payment status'
  },
  documents: {
    title: 'Document list',
    name: 'Document name',
    invoice: 'Invoice',
    kind: 'Type',
    kind_values: {
      certific: 'Certificate',
      fa_sammel: 'FA bulk invoice',
      ausfall: 'Cancellation invoice',
      bg_sammel: 'BG bulk invoice',
      frei_rg: 'Free invoice'
    },
    time: 'Time',
    size: 'Size',
    upload_title: 'Upload document',
    upload_button: 'Upload',
    upload_file: 'Select file',
    upload_types: 'Allowed types: {types}',
    upload_max_size: 'Maximum size: {size}',
    upload_error_client: 'Please select a client first.',
    upload_error_file: 'Please select a file.',
    upload_error_size: 'File is too large (max {size}).',
    upload_error_type: 'File type not allowed. Allowed: {types}.',
    upload_error_generic: 'File could not be uploaded.',
    download_error_title: 'Download failed',
    download_error_generic: 'File could not be downloaded.',
    delete_confirm: 'really delete'
  },
  paginator: {
    site: 'Entries per page',
    from: 'from'
  },
  table: {
    no_data: 'No data available',
    columns: 'Columns',
    info: 'Info',
    select_columns: 'Select columns',
    selected_one: '1 record selected.',
    selected_many: '{count} records selected.'
  },
  common: {
    validationErrors: 'Please check the highlighted fields.',
    processing: 'Processing …',
    from: 'From',
    none: 'none',
    show: 'Show',
    email: 'Email',
    description: 'Description',
    amount: 'Amount',
    date: 'Date',
    service: 'Service',
    last_change: 'Last change',
    billing: 'Billing',
    payment_method: 'Payment method',
    name: 'Name',
    website: 'Website',
    phone: 'Phone',
    course_type: 'Course type',
    appointment: 'Date',
    search: 'Search',
    duplicate_check: 'Duplicate check',
    employee: 'Employees',
    link: 'Link',
    noResults: 'No options',
    saved: 'Saved',
    deleted: 'Successfully deleted',
    error: 'Error',
    back: 'Back'
  },
  loginPage: {
    dbUnavailableTitle: 'Database connection unavailable',
    dbUnavailableMessage: 'The connection to the database cannot currently be established. Please try again shortly.',
    retry: 'Retry'
  },
  cliSampleDemo: {
    routeTitle: 'Queue/Mercure demo',
    title: 'Queue, CLI and Mercure demo',
    description: 'Starts a 30-second timer as a CLI command through the queue and updates the run status through Mercure.',
    startButton: 'Start demo',
    routeHint: 'Available at /main/queue-mercure-sample',
    idleStatus: 'not started',
    progressLabel: 'Progress',
    progressText: '{elapsed} of {seconds} seconds completed ({progress}%)',
    eventsTitle: 'Events',
    noEvents: 'No events received yet.',
    startError: 'Could not start the demo.',
    fields: {
      runId: 'Run ID',
      status: 'Status',
      source: 'Source',
      topic: 'Mercure topic'
    },
    genericTriggerLabel: 'Generic task trigger (demo)'
  },
  organisationSettings: {
    title: 'Organisation data',
    module_hint: 'View for module: {module}',
    module_select: 'Module',
    membernumber_status: {
      active: 'Active',
      inactive: 'Inactive'
    },
    modules: {
      kdb: 'Customers',
      fmv: 'Members',
      ktv: 'Courses',
      kifam: 'Family',
      ls: 'Academy',
      av: 'Active members'
    },
    cards: {
      central: 'Central setting',
      module: 'for module',
      organisation: 'Organisation data',
      bank: 'Bank {number}',
      letterhead: 'Letterhead and form data',
      sepa: 'SEPA',
      barcode: 'Barcode number',
      member_number: 'Number range',
      annual_receipts: 'Annual receipts',
      flight_service: 'Flight service',
      course_billing: 'Billing and number range',
      export_interface: 'Export Interface',
      vbg: 'VBG login',
      bg_rate: 'BG rate',
      drk_server: 'DRK server login',
      ortsvereine: 'Local associations',
      marketing_groups: 'Marketing groups',
      newspaper: 'Newspaper titles'
    },
    barcode: {
      dialog_title: 'Edit barcode number',
      selection: 'Selection',
      format: 'Barcode format',
      variables: {
        year: 'Year <jahr> ({example})',
        date: 'Date <datum> ({example})',
        timestamp: 'Timestamp <zeitstempel>',
        client_id: 'Client ID <kunden_id>',
        counter: 'Barcode counter <counter> ({example})'
      },
      notice: 'The barcode is generated from the configured variables whenever an invoice is created. It is fixed for the individual invoice and cannot be changed afterwards.',
      validation_characters: 'Supported characters are A–Z, numbers, spaces, -.$/+% and the offered variables.',
      validation_max_length: 'The barcode format must not exceed 255 characters.',
      saved: 'Barcode number was saved.',
      save_error: 'Barcode number could not be saved.'
    },
    lists: {
      title_label: 'Title',
      description_label: 'Description',
      no_data: 'No entries available',
      default_hint: 'Default entries (italic) cannot be edited or deleted.',
      validation_required: 'Required field',
      validation_max_length: 'Maximum 255 characters',
      saved: 'Saved successfully',
      deleted: 'Deleted successfully',
      save_error: 'Error while saving',
      delete_error: 'Error while deleting',
      load_error: 'Entries could not be loaded',
      module_label: 'Module',
      module_all: 'all'
    },
    help: {
      main_bank: 'Active means: Bank 2 is the main bank. Inactive means: Bank 1 is the main bank.',
      invoices_entrepreneur: 'According to § 14 Para. 4 UStG, the full name of the entrepreneur must be stated on invoices.',
      person_1_title: 'Letter variable: VD_Person_1_Title',
      person_1_name: 'Letter variable: VD_Person_1_Name',
      person_2_title: 'Letter variable: VD_Person_2_Title',
      person_2_name: 'Letter variable: VD_Person_2_Name',
      check_paypal_invoice: 'Automatic invoice creation for PayPal payments in the invoice journal\n\nIf the course fee was paid via PayPal and the participant was imported through online registration, an invoice is automatically added to the invoice journal under "Booked Invoices".',
      membernumber_check: 'Member number generation\n\nThe prefix is a fixed value; the following\nnumber is incremented automatically (+1).\n\nEvery member relation that leaves the member number field empty receives a new number automatically.\n\nExample: "477" "000001"\nNew member no.: 477000002, 477000003, 477000004 etc.\n\nIf a higher number is manually added for a customer, the highest number is always used as the reference value.\n\nExample: 5999999999 next 6000000000\n\nAfter activation, changes are only possible through DDL!',
      flight_operations: 'The flight service selection only becomes available once the annual membership amount has been reached.',
      flight_current_cost: 'The new rate is used when an amount is entered and the year has been selected in the "from year" field.',
      flight_year: 'The "from year" field determines from which year the new rate applies.',
      flight_operations_cost: 'The old rate is used until an amount has been entered in the "new rate" field in combination with the "from year" field.'
    },
    headings: {
      invoices_entrepreneur: 'For invoices: Name of the entrepreneur pursuant to § 14 Para. 4 USTG:',
      invoice_number_range: 'Invoice number',
      export_interface: 'Export Interface'
    },
    iban_invalid: 'Invalid IBAN',
    iban_calculate_error: 'BLZ and account number do not yield a valid IBAN',
    fields: {
      name: 'Name',
      street: 'Street',
      zipcode: 'ZIP',
      city: 'City',
      phone: 'Phone',
      fax: 'Fax',
      email: 'Email',
      webpage: 'Website',
      level: 'KV, LV, ...',
      bank_name: 'Bank name',
      account_holder: 'Account holder',
      account_number: 'Account no.',
      bank_code: 'Bank code',
      iban: 'IBAN',
      bic: 'BIC',
      purpose_prefix: 'Purpose prefix',
      main_bank: 'Main bank',
      bank_1: 'Bank 1',
      bank_2: 'Bank 2',
      person_1_title: 'Person 1 title',
      person_1_name: 'Person 1 name',
      person_2_title: 'Person 2 title',
      person_2_name: 'Person 2 name',
      sales_tax: 'VAT ID',
      club_register: 'Club register',
      district: 'District',
      land: 'State',
      district_court: 'District court',
      tax_office: 'Tax office',
      tax_number: 'Tax no.',
      responsible_doctor: 'Resp. doctor',
      distance_price: 'Mileage rate',
      creditor_id: 'Creditor ID',
      membernumber_prefix: 'Member number prefix',
      membernumber_from: 'Member number start',
      membernumber_check: 'Automatic active',
      years_of_receipt: 'Min. AR private person',
      years_of_receipt_firm: 'Min. AR company',
      flight_operations: 'Min. flight service amount',
      flight_operations_cost: 'old rate',
      flight_current_cost: 'new rate',
      flight_year: 'from year',
      coursenumber_from: 'Course number start',
      account_tn_type: 'TN invoice',
      account_dz_type: 'Lecturer billing',
      letter_invoice_prefix: 'Invoice number prefix',
      letter_invoice_from: 'Invoice number start',
      check_paypal_invoice: 'auto. PayPal inv.',
      bg_rate_current_year: 'current year',
      bg_rate_next_year: 'next year',
      vbg_idnumber: 'VBG member number',
      vbg_username: 'VBG user',
      vbg_password: 'VBG password',
      drkserver_username: 'DRK server user',
      drkserver_password: 'DRK server password',
      drkserver_org_id: 'DRK server organisation ID',
      drkserver_org_name: 'DRK server organisation'
    },
    messages: {
      saved: 'Organisation data was saved.',
      load_error: 'Organisation data could not be loaded.',
      save_error: 'Organisation data could not be saved.'
    }
  },
  interfaceSettings: {
    title: 'Interfaces',
    cards: {
      details: '{interface} settings'
    },
    actions: {
      save: 'Save'
    },
    radios: {
      tn: 'TN invoice',
      dz: 'Lecturer billing'
    },
    interfaces: {
      entire: 'Entire',
      wilkenp5: 'WilkenP5',
      diamant: 'Diamant',
      sage: 'Sage',
      datev: 'Datev',
      navision: 'Navision',
      swing: 'Swing',
      excel: 'Excel',
      fibunet: 'Fibunet',
      micos: 'Micos',
      simba: 'Simba',
      addison: 'Addison (Beta)',
      sap: 'SAP',
      winline: 'WinLine',
      egecko: 'eGecko',
      fs: 'FS',
      scopevisio: 'Scopevisio',
      sage_hersfeld: 'Sage Hersfeld'
    },
    sections: {
      datev_column_labels: 'Column labels',
      datev_ddl_standard: 'DDL standard'
    },
    options: {
      none: 'none',
      prefixed_00: 'prefixed 00',
      course_number: 'Course number',
      invoice_number: 'Invoice number',
      manual: 'manual',
      bookings: 'Bookings',
      debtors_and_bookings: 'Debtors and bookings',
      standard: 'Standard',
      standard_ii: 'Standard II',
      sz_fa: 'Self-payer/company',
      all: 'all',
      cost_center: 'Cost center',
      name: 'Name',
      name_street: 'Name and street',
      bookings_only: 'bookings only',
      datev_ddl_standard: 'DDL standard',
      datev_kv_emmendingen: 'KV Emmendingen',
      datev_kv_schwerin: 'KV Schwerin',
      datev_kv_solingen: 'KV Solingen',
      datev_kv_wolfach: 'KV Wolfach',
      datev_standard_ii: 'Datev standard II',
      datev_hochtaunus: 'Hochtaunus',
      datev_kv_muelheim: 'KV Mülheim a.d. Ruhr',
      yes: 'Yes',
      no: 'No',
      belegfeld2_sofort: 'Immediately',
      belegfeld2_auto_sz_bg: 'auto. 14 days (SZ), 30 days (BG)',
      belegfeld2_skonto_14_30: '14 days 2% discount, 30 days net',
      belegfeld2_manual: 'manual entry',
      invoice_fields_34: 'Invoice no. fields (3,4)',
      datev_buchtxt_auto: 'auto. text course no. / course name / (from-to)',
      datev_buchtxt_participant: 'Participant (first, last name or company)',
      datev_buchtxt_recipient: 'Invoice recipient, course no., participant count',
      four: '4',
      five: '5',
      six: '6',
      datev_kost2_no: 'No (empty)',
      datev_kost2_yes: 'Yes (cost centre of the course default)'
    },
    fields: {
      export_type: 'Format',
      active: 'Active',
      account_tn_type: 'TN invoice',
      account_dz_type: 'Lecturer billing',
      mandant_id: 'Client ID',
      mandant: 'Client',
      deb_beginn_option: 'Debtor prefix selection',
      deb_beginn: 'Debtor prefix format',
      deb_sz: 'Dummy self-payer debtor no.',
      rgn_nr_beginn: 'Invoice no. starts with',
      rgn_date: 'Cash payer booking date',
      mitbuchkto: 'Posting account',
      erloeskonto: 'Revenue account',
      kostenstelle: 'Cost center',
      mahnstrg: 'Dunning strategy',
      zahlungsbed_bg: 'Payment terms (BG)',
      zahlungsbed_sz_fa: 'Payment terms (company/self-payer)',
      buchtxt_option: 'Booking text selection',
      buchtxt: 'Booking text',
      buch_datum: 'Booking date',
      rng_nr_current: 'Invoice number',
      rng_to_nr_msg: 'max. invoice number',
      rng_to_nr_pre_msg: 'Warning before max. invoice number',
      deb_nr_current: 'Debtor number',
      deb_to_nr_msg: 'max. debtor number',
      deb_to_nr_pre_msg: 'Warning before max. debtor number',
      buch_nav_exp: 'Export format selection',
      buch_dat_exp: 'Export format selection',
      expfeld1: 'Export field 1',
      expfeld2: 'Export field 2',
      expfeld3: 'Export field 3',
      expfeld4: 'Export field 4',
      sz_out: 'Exclude self-payers',
      belegfeld2_mode: 'Document field 2 options',
      belegfeld2: 'Document field 2 manual entry',
      batch_booking: 'Batch booking',
      extf_activ_debitoren: 'Batch + debtors',
      consultant_number: 'Consultant number',
      mandant_number: 'Client number',
      datev_belegnummer: 'Document number',
      deb_only_scope: 'Debtor no. for',
      deb_only_sz_fa: 'Debtor no.',
      recipient_in_invoice: 'Recipient in bookings',
      buchtxt_max_len: 'Booking text length',
      gs_and_rng: 'Credit note with linked invoice',
      extf_b_leistungsdatum: 'Service date',
      extf_i_sachkontenlaenge: 'G/L account length',
      content_kost1: 'Content of cost center 1',
      bool_kost2: 'Cost center 2 from course defaults',
      extf_bez_umsatz: 'Revenue',
      extf_bez_sollhaben: 'Debit/Credit',
      extf_bez_wkzumsatz: 'Currency',
      extf_bez_konto: 'Account',
      extf_bez_gegenkonto: 'Contra account',
      extf_bez_buschluessel: 'BU key',
      extf_bez_kostenst1: 'Cost center 1',
      extf_bez_leistungsdatum: 'Service date',
      firmennummer: 'Company number',
      booking_period: 'Booking period',
      rgn_to_belegnr: 'Invoice no. as document no.',
      zusatzfeld_in_buchungstext: 'OP extra field in booking text',
      k_ks_kursnr: '(K)-> cost object = course no.',
      projectdata_kursnr: '(K)-> project with course no.',
      renr_o_bindestr: 'Invoice no. without hyphen',
      kursnr_o_bindestr: 'Course no. without hyphen',
      mit_posten: '(G) include items',
      with_masterdata: '(S) include master data',
      diamant_split_export_files: 'Split file (debtors/bookings)',
      diamant_f_geschaeftskennzeichen: 'F (5) business indicator',
      diamant_f_belegart: 'F (6) document type',
      diamant_g_steuerschluessel_aus_mwst: 'G (4) derive from VAT',
      diamant_g_steuersatz_leer: 'G (5) empty tax rate',
      diamant_s_bezeichnung_format: 'Address data (6)',
      diamant_s_mahnart: 'S (14) dunning type',
      diamant_s_zahlungskondition: 'S (16) payment terms',
      diamant_s_konzernobjekt: 'S (63) group object',
      diamant_v_barcode_quelle: 'V record barcode',
      belegart: 'Document type',
      buchungskreis: 'Company code',
      deb_sz_general: 'General self-payer debtor no.',
      bgfa_frist: 'Payment term (company or BG)',
      sz_frist: 'Payment term (self-payer)',
      firma_nr: 'Company no.',
      dimension01_list: 'Use Dimension01',
      dimension01: 'Dimension01',
      kontonummer: 'Account number',
      rechnungskondition: 'Invoice condition',
      privat_sachk_kostart: 'Private persons G/L account/cost type',
      positionstext: 'Use item text',
      positionstext_opt: 'Item text with',
      posten_kurs: 'Item "course" in document position',
      fibu_kore_belegpos: 'FibuKore position (cost center/cost object)',
      export_file: 'Export',
      ktokorrentkennzeichen: 'Subledger/main ledger link',
      zahlungsbedingung: 'Payment condition',
      datev_booking_year: 'Booking year',
      datev_period_start: 'Booking period start',
      export_paypal_txid: 'PayPal transaction no.',
      deb_paypal: 'Debtor no. for PayPal',
      datev_mit_posten: 'With items',
      bu_schluessel_19: 'BU key 19%',
      bu_schluessel_7: 'BU key 7%',
      bu_schluessel_0: 'BU key 0%'
    },
    help: {
      account_tn_type: 'Export format for participant invoices.',
      account_dz_type: 'Export format for lecturer billing.',
      mandant_id: 'Client ID of the target accounting system.',
      mandant: 'Client in the target accounting system.',
      deb_beginn_option: 'Selection for a prefixed debtor number.',
      deb_beginn: 'Debtor number export format.',
      deb_sz: 'Debtor number for self-payers without an individual number.',
      rgn_nr_beginn: 'Format or starting part of the invoice number in the export.',
      rgn_date: 'Booking date for cash payers.',
      mitbuchkto: 'Posting account in the export.',
      erloeskonto: 'Revenue account in the export.',
      kostenstelle: 'Cost center in the export.',
      mahnstrg: 'Dunning strategy for the interface.',
      zahlungsbed_bg: 'Payment terms for employers liability insurance associations.',
      zahlungsbed_sz_fa: 'Payment terms for companies and self-payers.',
      buchtxt_option: 'Defines how the booking text is built.',
      buchtxt: 'Booking text; old interfaces may limit it to 30 characters.',
      buch_datum: 'Booking date written to the export file.',
      rng_nr_current: 'Current invoice number from the client settings.',
      rng_to_nr_msg: 'Maximum invoice number for warnings.',
      rng_to_nr_pre_msg: 'Warning threshold before the invoice number range is exhausted.',
      deb_nr_current: 'Current debtor number from the client settings.',
      deb_to_nr_msg: 'Maximum debtor number for warnings.',
      deb_to_nr_pre_msg: 'Warning threshold before the debtor number range is exhausted.',
      buch_nav_exp: 'Defines the Navision export scope.',
      buch_dat_exp: 'Defines the Datev export scope.',
      expfeld1: 'Custom export field 1.',
      expfeld2: 'Custom export field 2.',
      expfeld3: 'Custom export field 3.',
      expfeld4: 'Custom export field 4.',
      sz_out: 'Exclude self-payers from course overview export.',
      belegfeld2_mode: 'Source for document field 2.',
      belegfeld2: 'Manual value for document field 2.',
      batch_booking: 'Enable batch booking.',
      extf_activ_debitoren: 'Export batch bookings together with debtor data.',
      consultant_number: 'Datev consultant number.',
      mandant_number: 'Datev client number.',
      datev_belegnummer: 'Source for the document number.',
      deb_only_scope: 'Defines for which recipients debtor numbers are used.',
      deb_only_sz_fa: 'Debtor number for the selected scope.',
      recipient_in_invoice: 'Print recipient next to booking text.',
      buchtxt_max_len: 'Maximum booking text length.',
      gs_and_rng: 'Export credit notes with linked invoice.',
      extf_b_leistungsdatum: 'Include service date in the export.',
      extf_i_sachkontenlaenge: 'G/L account length for Datev export.',
      content_kost1: 'Source for cost center 1.',
      bool_kost2: 'Use cost center 2 from course defaults.',
      extf_bez_umsatz: 'Column label for revenue.',
      extf_bez_sollhaben: 'Column label for debit/credit.',
      extf_bez_wkzumsatz: 'Column label for currency.',
      extf_bez_konto: 'Column label for account.',
      extf_bez_gegenkonto: 'Column label for contra account.',
      extf_bez_buschluessel: 'Column label for BU key.',
      extf_bez_kostenst1: 'Column label for cost center 1.',
      extf_bez_leistungsdatum: 'Column label for service date.',
      firmennummer: 'Company number for the interface.',
      booking_period: 'Booking period for Diamant.',
      rgn_to_belegnr: 'Use invoice number as document number.',
      zusatzfeld_in_buchungstext: 'Include OP extra field in the booking text.',
      k_ks_kursnr: 'Use course number as cost object.',
      projectdata_kursnr: 'Fill project with course number.',
      renr_o_bindestr: 'Export invoice number without hyphens.',
      kursnr_o_bindestr: 'Export course number without hyphens.',
      mit_posten: 'Include items in the export.',
      with_masterdata: 'Include master data in the export.',
      diamant_split_export_files: 'Write debtors and bookings to separate files.',
      diamant_f_geschaeftskennzeichen: 'Diamant F record field 5.',
      diamant_f_belegart: 'Diamant F record field 6.',
      diamant_g_steuerschluessel_aus_mwst: 'Derive tax key from VAT.',
      diamant_g_steuersatz_leer: 'Leave tax rate empty in G record.',
      diamant_s_bezeichnung_format: 'Address data format in S record.',
      diamant_s_mahnart: 'Dunning type in S record.',
      diamant_s_zahlungskondition: 'Payment terms in S record.',
      diamant_s_konzernobjekt: 'Group object in S record.',
      diamant_v_barcode_quelle: 'Barcode source in V record.',
      belegart: 'Document type for the interface.',
      buchungskreis: 'Company code for the interface.',
      deb_sz_general: 'Use debtor number stored for self-payers only.',
      bgfa_frist: 'Payment term for companies or BG.',
      sz_frist: 'Payment term for self-payers.',
      firma_nr: 'Company number for eGecko.',
      dimension01_list: 'Use Dimension01 in the export.',
      dimension01: 'Value for Dimension01.',
      kontonummer: 'Account number for the interface.',
      rechnungskondition: 'Invoice condition for the interface.',
      privat_sachk_kostart: 'G/L account and cost type for private persons.',
      positionstext: 'Use item text in document positions.',
      positionstext_opt: 'Source for item text.',
      posten_kurs: 'Include item "course" in document position.',
      fibu_kore_belegpos: 'Configuration for cost center/cost object in FibuKore position.',
      export_file: 'Defines which files are exported.',
      ktokorrentkennzeichen: 'Links subledger accounting with main ledger accounting.',
      zahlungsbedingung: 'Payment condition in the target accounting system.',
      datev_booking_year: 'Booking year of the export; empty = current year.',
      datev_period_start: 'Start of the booking period (month); empty = month of the voucher date.',
      export_paypal_txid: 'Also export the PayPal transaction number.',
      deb_paypal: 'Debtor number for invoices paid with PayPal.',
      datev_mit_posten: 'Export invoice items as separate booking lines (split booking).',
      bu_schluessel_19: 'BU key for 19% VAT.',
      bu_schluessel_7: 'BU key for 7% VAT.',
      bu_schluessel_0: 'BU key for VAT-free items.'
    },
    messages: {
      saved: 'Interfaces were saved.',
      load_error: 'Interfaces could not be loaded.',
      save_error: 'Interfaces could not be saved.',
      no_settings: 'This format has no settings.'
    }
  },
  client: {
      last_change_tooltip: 'Last change: {date}\nUser: {user}',
      customer_copy: 'Customer copy',
      club_data: 'Association data',
      more_options: 'more options',
      moduleAssignmentTooltip: 'Module assignment: {modules}',
      headquarters_suffix: '( Headquarters )',
      search_count: 'Participants: {count}',
      search_placeholder_person: 'Last name, first name',
      search_placeholder_company: 'Company name',
      delete_client: 'Delete customer',
      delete_client_confirm: 'Do you really want to delete this customer?',
      delete_client_zentrale_warning: 'This customer is a parent company. The following companies will lose their connection:',
      delete_client_courses_warning: 'The customer is registered for the following active or future courses:',
      delete_client_blocked: 'The customer cannot be deleted because they still have customer relations in the following modules: {modules}. If necessary, delete the customer relation(s) first, either in the individual modules or in the customer mask under "Customer relation".',
      delete_client_not_possible: 'The customer cannot be deleted here.',
      delete_client_module: {
        av: 'Volunteers',
        fmv: 'FMV',
        ktv: 'Courses',
        ls: 'Academy',
        kifam: 'Family'
      },
      wizard: {
        title_person: 'New customer',
        title_company: 'New company',
        title_copy_person: 'Customer copy – person',
        title_copy_company: 'Customer copy – company',
        copy_banner_title: 'You are creating a copy of {name} — please review all details.',
        copy_banner_included: 'Copied: master data, contact details, invoice address, company details (VAT ID, tax number, payer, cost center), matching customer relation.',
        copy_banner_excluded: 'Not copied: bank details, mandate number, member number, debtor account — please add these again if needed.',
        copy_badge: 'Copy',
        steps: {
          stammdaten: 'Master data',
          weitere: 'Additional details',
          extras: 'Bank & invoice address',
          summary: 'Summary'
        }
      },
      new_person_tooltip: 'new customer',
      new_company_tooltip: 'new company',
      title_master: 'Master data',
      title_employee: 'Contacts/Employees',
      employee_overview: 'Employee overview',
      title_office: 'Office',
      title_contact: 'Contact data',
      title_invoice_adress: 'Invoice address',
      default_invoice_address: 'Default invoice address',
      course_invoice_addresses: 'Course invoice addresses',
      open_course: 'Open course',
      title_bank: 'Bank details',
      bank_update_title: 'Update bank data',
      bank_update_message: 'The IBAN check returned different values. Update BIC and bank name automatically?',
      title_additional_information: 'Additional information',
      title_customer_account: 'Customer account',
      invoice_adress_opt: 'Invoice address',
      anrede: 'Salutation',
      title: 'Title',
      firstname: 'First name',
      lastname: 'Last name',
      customer_id: 'Customer ID',
      customer_number: 'Membership number',
      password: 'Password',
      deb_konto: 'Debtor number',
      drk_serverId: 'DRK server ID',
      language: 'Language',
      family_status: 'Family status',
      birthday: 'Birthday',
      age: 'Age',
      birthplace: 'Place of birth',
      conspicuous: 'Conspicuous',
      greetings: 'Letter salutation',
      company_org_1: 'Company/Org',
      company_org_2: 'Company/Org add-on',
      responsible_bg: 'Responsible BG',
      vat_id: 'VAT ID',
      tax_code: 'Tax number',
      cost_center: 'Cost center',
      parent_company: 'Head office',
      position: 'Position',
      department: 'Department',
      work: 'Occupation',
      function: 'Function',
      category: 'Category',
      kategorie: 'Category',
      marketing_group: 'Marketing group',
      marketing_groups: 'Marketing groups',
      marketing_groups_none: 'No marketing groups available for this module',
      free_field_1: 'Keyword 1',
      free_field_2: 'Keyword 2',
      comment_notice: 'Comment',
      comment_note: 'Note',
      addition_notice: 'Keyword 3',
      reference_person: 'Reference person',
      phone_private: 'Phone (private)',
      phone_office: 'Phone (office)',
      phone_mobile: 'Mobile',
      street: 'Street',
      houseNumber: 'House number',
      fax: 'Fax',
      zip: 'ZIP',
      city: 'City',
      addition: 'Address addition',
      country: 'Country',
      used_in_modul: 'Used in module',
      used_in_modules: 'Used in',
      bank_not_in_module: 'not stored for {module}',
      bank_replace_title: 'Replace bank account',
      bank_replace_message: 'This module already uses another bank account. Replace it with this one?',
      account_holder: 'Account holder',
      bankname: 'Bank name',
      iban: 'IBAN',
      bic: 'BIC',
      konto: 'Account',
      blz: 'Bank code',
      mandat: 'Mandate',
      mandat_date: 'Mandate date',
      key_number: 'Key number',
      referencePersonTyp: 'Reference person type',
      reference_person_hint: 'Only existing customers can be assigned as reference persons.',
      relation: 'Customer relation',
      type: 'Type',
      main_typ: 'Contact/Employee',
      main_contact_main: 'Primary contact',
      main_contact_contact: 'Contact person',
      legend: {
        title: 'Legend'
      }
  },
  course: {
    attendance_unsubscribed: 'deregistered (black)',
    attendance_noshow: 'NoShow (red)',
    attendance_appeared: 'Attended',
    title_course_data: 'Course data',
    course_name: 'Course description',
    course_no: 'Course no.',
    short: 'Short',
    title: 'Course title',
    to: 'to',
    appeared: 'attended',
    invoice_number: 'Invoice number',
    invoice_type: 'Invoice type',
    purpose: 'Purpose',
    billing_period: 'Billing period',
    group_course: 'Delivery mode',
    group_payment: 'Payment',
    filter_course_no: 'Course number',
    filter_from: 'course from',
    filter_to: 'course to',
    version: 'Course version',
    internal_name: 'Course number',
    vbg: 'VBG course number',
    is_bg: 'BG only participants',
    bg_typ: 'BG type',
    bg_payment: 'BG fee',
    payment: 'Course fee',
    mwst: 'VAT',
    street: 'Street',
    plz: 'Postal code',
    city: 'City',
    title_course_days: 'Dates',
    event_status: 'Course status',
    status_planned: 'planned',
    status_cancelled: 'cancelled',
    status_conducted: 'in progress',
    status_closed: 'closed',
    event_status_tooltip: 'Course overview - list color:\n\n1. Status: "in progress", but the minimum participant count has not been reached == "red"\n2. Status: "cancelled" == "grey"',
    event_ue: 'Teaching units',
    hide_webdisplay: 'Hide web display',
    hide_ongoing: 'Late entry',
    maskcharge: 'Mask batch alphanumeric',
    helper_name: 'Training assistant',
    title_course_places: 'Course places',
    course_places_auto_calculated: 'The values are calculated automatically.',
    student_amount_now: 'Participants to date',
    student_register_now: 'Open online registrations',
    tn_reserved: 'Reservations',
    student_amount_min: 'Participants min.',
    student_amount_max: 'Participants max.',
    student_amount_free: 'Free seats',
    title_course_event: 'Course event',
    association_mandant: 'Association/tenant',
    org_id: 'Org_id',
    org_typ: 'Organization type',
    title_general_notice: 'General note',
    title_online_presence: 'Publication',
    title_course_location: 'Course location',
    kursort_info_tooltip: 'The course location shown here refers to the first date of the course, which can also be found in the course data. If a course has multiple dates with different course locations, this can be seen in the schedule overview under the "Dates" tab.',
    title_contributions: 'Fees',
    title_general_remarks: 'General remarks',
    organisation: 'Local association',
    bookability: 'Bookability',
    bookability_public: 'public',
    bookability_closed: 'closed',
    bookability_internal: 'internal',
    bookability_tooltip: '<b>public/open:</b> An open course is accessible to everyone.\n<b>closed:</b> A closed course is not accessible to everyone and takes place in or for a company. It can only be booked via the reservation link and does not appear in the web search.\n<b>internal:</b> An internal course is intended for your own staff and is published on your own website.\n\nPublic and internal courses are automatically included in the web search.',
    event_type: 'Course type',
    event_type_open: 'open',
    event_type_closed: 'closed',
    event_ue_present: 'Teaching units (on-site)',
    event_ue_online: 'Teaching units (online)',
    company_portal: 'Company portal',
    show_online: 'Show course online',
    company_portal_tooltip: 'Company portal\n\nWith "Yes", the appointment is shown in the company portal.\nWith "No", the appointment is excluded from the company portal.\nException: the company where the course takes place.',
    hide_ongoing_tooltip: 'Late entry\n\nWith "Yes", entry into ongoing multi-day courses via the website online form is possible.\nWith "No", no late entry is possible: once the course starts, it will no longer be listed in the schedule display on the website.',
    application_deadline_date: 'Application deadline',
    publish_date: 'Course published from',
    location_name: 'Course location',
    location_room_type: 'Room type',
    location_site: 'Site',
    location_room: 'Building/Floor/Room',
    location_contact_person: 'Company contact person',
    payment_course: 'Course fee',
    revenue_account: 'Revenue account',
    payment_external: 'External course fee',
    revenue_account_external: 'External revenue account',
    payment_hik: 'HIK course fee',
    revenue_account_hik: 'HIK revenue account',
    vat_none: 'no VAT',
    vat_seven: '7% VAT',
    vat_nineteen: '19% VAT',
    note_gross_incl_vat: 'Gross incl. VAT.',
    price_surcharges: 'Price surcharges',
    price_surcharges_bookable_online_only: 'Bookable online only',
    price_surcharges_update_title: 'Update price surcharges',
    price_surcharges_update_message: 'Do you want to apply and save the data from the course defaults?',
    price_surcharges_update_empty: 'No price surcharges were found in the course defaults.',
    price_surcharges_update_error: 'The price surcharges could not be updated.',
    price_surcharges_update_missing_course_type: 'No course type is assigned to this course.',
    price_reductions: 'Reductions',
    price_reductions_update_title: 'Update reductions',
    price_reductions_update_message: 'Do you want to apply and save the data from the course defaults?',
    price_reductions_update_empty: 'No reductions were found in the course defaults.',
    price_reductions_update_error: 'The reductions could not be updated.',
    price_reductions_update_missing_course_type: 'No course type is assigned to this course.',
    course_designations: 'Course designations',
    surcharge_participant_invoice_item: 'Participant/invoice item surcharge',
    surcharge_per_participant_invoice_item: 'Surcharge per participant (invoice item)',
    reduction_course_fee: 'Course fee reduction',
    reduction_per_course_fee: 'Reduction per participant (course fee)',
    reduction_type: 'Discount type',
    surcharge_selection: 'Selection',
    value: 'Value',
    editor: 'Editor',
    activation_date: 'Activation date',
    include_vat: 'incl. VAT',
    gross_amount: 'Amount (gross)',
    surcharge_type_currency: 'Amount',
    surcharge_type_percentage: 'Percentage',
    flat_rate: 'Flat rate',
    note_flat_rate_without_participant_prices: 'Full price without participant-based prices',
    general_remarks: 'General remarks',
  },
  courseCreate: {
    wizard_title: 'Create new course',
    step_kursdaten: 'Course data',
    step_beitraege: 'Contributions',
    step_online: 'Online & Remarks',
    step_summary: 'Summary',
    confirm_title: 'Create course',
    confirm_message: 'Save the course now?',
    field_required: 'Required field',
    validation_required: 'Please fill in all required fields.',
    saved_success: 'Course successfully created.',
    saved_error: 'Error creating the course.',
    post_save_title: 'Create participants or reservations?',
    post_save_message: 'Do you want to create participants or reservations for this course now?',
    ls_surcharge_hint: 'Surcharges and reductions can be configured after creation in the master data.',
  },
  courseMaterials: {
    title: 'Course materials',
    newMaterial: 'New material',
    dialogTitleNew: 'New material',
    tabs: {
      assignment: 'Assignment to courses'
    },
    assignMany: {
      tooltip: 'Add selected materials to course(s)',
      title: 'Assign {count} selected materials to course types',
      hint: 'The selected course types are added, existing assignments are kept. If a material lacks the module of a course type, it is added under "Available for modules".',
      noSelection: 'Please select one or more materials.',
      saved: '{added} assignments added for {materials} materials.'
    },
    wizard: {
      stepMaterial: 'Material',
      confirmTitle: 'Create material',
      confirmMessage: 'Do you want to save the material now?'
    },
    dialogTitleEdit: 'Edit material',
    detail: 'Material details',
    cancel: 'Cancel',
    notAssigned: 'not assigned',
    searchTooltip: 'Searches the name and number of the materials. Part of the term is enough, e.g. "Phantom" or "31".',
    notAssignedTooltip: 'The material is not assigned to any course designation and is therefore not charged in any course.',
    columns: {
      number: 'Number',
      name: 'Name',
      price: 'Price',
      count: 'Quantity',
      area: 'Area',
      courseday: 'per course day',
      modules: 'Modules',
      courseTypes: 'Course types',
      courseAssignment: 'Course assignm.',
      unitPrice: 'Unit price',
      participants: 'Partic.',
      totalPrice: 'Total price'
    },
    areaShort: {
      s: 'Partic.',
      c: 'Course'
    },
    area: {
      s: 'Participant material',
      c: 'Course material'
    },
    fields: {
      name: 'Name',
      number: 'Number',
      count: 'Quantity',
      countSuffix: 'pieces',
      pricePerParticipant: 'Price per participant',
      pricePerCourse: 'Price per course',
      courseday: 'per course day',
      modules: 'Available for modules',
      description: 'Description'
    },
    image: {
      label: 'Image',
      none: 'No image available',
      change: 'Change',
      uploaded: 'Image saved',
      deleted: 'Image deleted',
      deleteTitle: 'Delete image',
      deleteMessage: 'Do you really want to delete the image of this material?'
    },
    assignment: {
      title: 'Assignment to courses',
      available: 'Available courses',
      availableTooltip: 'The list shows the course designations of the modules selected under "Available for modules". If the module selection changes, the list changes as well.',
      assigned: 'Material for courses',
      courseDefault: 'Course designation',
      search: 'Search course designation',
      module: 'Module',
      required: 'Please assign at least one course designation.'
    },
    validation: {
      nameRequired: 'Please enter a name.',
      modulesRequired: 'Please select at least one module.'
    },
    delete: {
      title: 'Delete material',
      message: 'Do you really want to delete this material?'
    },
    migration: {
      title: 'Course materials from the old system',
      legendTransfer: 'Transfer from the old system',
      legendSeed: 'Sample materials',
      pendingIntro: 'The course materials of this organisation will be transferred from the old system:',
      previewMaterials: 'Materials: {count}',
      previewImages: 'Images to be copied: {count}',
      previewModules: 'Materials whose available modules will be stored: {count}',
      previewOrphaned: 'Assignments to course designations that no longer exist, which will be removed: {count}',
      previewImagesMissing: 'Note: {count} images no longer exist in the old system and will not be transferred.',
      emptyIntro: 'There are no materials yet. Should sample materials be created?',
      transferred: 'Transfer completed: {materials} materials, {images} images copied.',
      seeded: 'Sample materials created: {count}'
    },
    ofCourse: {
      title: 'Course materials: {name}',
      summary: 'Course days: {courseDays} · Participants: {participants}',
      selectHint: 'Select a material in the list to show its details.',
      csvError: 'The CSV export failed.'
    }
  },
  courseSummary: {
    actions: {
      newCourse: 'New course',
      csvExport: 'CSV export',
      associationData: 'Association data',
      moreOptions: 'More options',
      reset: 'Reset',
      filter: 'Filter',
      deleteTemplate: 'Delete template'
    },
    scopes: {
      searchTemplates: 'Search templates',
      currentCourses: 'Current courses',
      currentCoursesTooltip: 'Current courses for the upcoming months (from {date})',
      notBilledCourses: 'Unbilled courses',
      billedCourses: 'Billed courses',
      thisWeek: 'This week',
      thisMonth: 'This month',
      thisYear: 'This year'
    },
    filters: {
      courseNumber: 'Course number',
      courseName: 'Course title',
      courseFrom: 'Course from',
      courseTo: 'Course to',
      courseTypes: 'Course types',
      courseStatus: 'Course status',
      periodRange: 'Period',
      participant: 'Participants',
      teachers: 'Teachers',
      withoutTeachers: 'without teachers',
      withoutTeachersInline: 'without teachers',
      company: 'Company',
      companyCourse: 'Company course',
      freePlaces: 'Free places',
      freePlacesCount: 'Count',
      publishedFrom: 'Published from',
      localAssociation: 'Association data OV',
      courseOpenClosed: 'Course (open/closed/internal)'
    },
    options: {
      all: 'All',
      active: 'Active',
      inactive: 'Inactive',
      conducted: 'Conducted',
      cancelled: 'Cancelled',
      booked: 'Fully booked',
      free: 'Available',
      count: 'Count',
      pastCourses: 'Past courses',
      futureCourses: 'Future courses',
      withParticipants: 'With participants',
      withoutParticipants: 'Without participants',
      minTnNotReached: 'Min. participants not reached',
      maxTnExceeded: 'Max. participants exceeded',
      withoutTeachers: 'Courses without teachers',
      onlyUnsettled: 'Not billed',
      onlySettled: 'Billed',
      onlyFreePlaces: 'Courses with free places',
      emptyLocalAssociation: 'Empty'
    },
    columns: {
      number: 'No.',
      numberTooltip: 'Course no.',
      contraction: 'Abbr.',
      contractionTooltip: 'Abbreviation',
      designation: 'Title',
      designationTooltip: 'Course title',
      localAssociation: 'Association data OV',
      day: 'Day',
      begin: 'Start',
      beginTooltip: 'Start',
      at: 'at',
      end: 'End',
      min: 'Min.',
      minTooltip: 'Minimum participants',
      max: 'Max.',
      maxTooltip: 'Maximum participants',
      places: 'Spots',
      placesTooltip: 'Places',
      reservations: 'Res.',
      reservationsTooltip: 'Reservation',
      participantsShort: 'Part.',
      participantsTooltip: 'Participants',
      companyOrganizer: 'Comp./Org.',
      companyOrganizerTooltip: 'Company / organizer',
      vbg: 'VBG',
      vbgTooltip: 'VBG no.',
      teachers: 'Teach.',
      teachersTooltip: 'Teachers',
      room: 'Room',
      place: 'Place',
      print: 'Print',
      billingShort: 'Bill.',
      billed: 'Billed'
    },
    headerGroups: {
      course: 'Course',
      date: 'Date',
      participants: 'Participants',
      event: 'Event'
    },
    legend: {
      title: 'Color legend',
      minimumReached: 'Blue border: Minimum number of participants has been reached',
      minimumMissing: 'Red border: Minimum number of participants has not been reached',
      cancelled: 'Grey border: Course is cancelled',
      teacherWarning: 'Red !: Conducted courses have dates without assigned teachers'
    },
    tooltips: {
      participantStatus: 'Participants: {current} / Minimum participants: {minimum}',
      minimumReached: 'The minimum number of participants has been reached.',
      minimumMissing: 'The minimum number of participants has not been reached.',
      noParticipants: 'There are no participants.',
      teacherWarning: 'Warning: No teacher is assigned for {count} date(s).',
      freePlacesBooked: 'Shows only courses without any free places.',
      freePlacesAvailable: 'Shows only courses with at least one free place.',
      freePlacesCount: 'Shows courses with exactly this number or more free places (free places ≥ value).',
      publishedFrom: 'Shows courses published up to and including this date.\nCourses without a date are always visible.'
    },
    errors: {
      flagUpdate: 'Change could not be saved',
      templateSave: 'Template could not be saved',
      templateDelete: 'Template could not be deleted'
    },
    messages: {
      templateSaved: 'Template has been saved',
      templateDeleted: 'Template has been deleted',
      templateExists: 'A saved template already exists for these filters'
    },
    dialogs: {
      saveTitle: 'Save search template',
      deleteTitle: 'Delete search template',
      templateNameLabel: 'Template name',
      templateNameRequired: 'Please enter a name',
      deleteMessage: 'Delete search template "{name}"?'
    }
  },
  courseTeachers: {
    title: 'Teachers',
    tabs: {
      teacherList: 'Teacher list',
      certificates: 'Certificates'
    },
    filters: {
      lastname: 'Last name',
      city: 'City/district',
      function: 'Function',
      courseDefault: 'Course title',
      validFrom: 'Valid from',
      validTo: 'Valid to'
    },
    columns: {
      name: 'Name',
      functionTask: 'Function/task',
      phone: 'Phone',
      email: 'Email',
      organisation: 'Organisation',
      courseTitle: 'Course title',
      courseType: 'Course type',
      teacherName: 'Teacher/name',
      certificateNumber: 'Number',
      validFrom: 'Valid from',
      validTo: 'Valid to',
      createdAt: 'Issued on',
      note: 'Note'
    },
    actions: {
      edit: 'Edit'
    }
  },
  bgList: {
    title: 'BG list',
    filters: {
      search: 'Search',
      searchTooltip: 'Searches: employers\' liability insurance association, BG short, zip, city, debitor number'
    },
    columns: {
      name: 'BG short',
      fullname: 'Employers\' liability insurance association',
      iban: 'IBAN',
      zip: 'Zip',
      city: 'City',
      debitorNumber: 'Debitor number',
      unfallkasse: 'Unfallkasse'
    }
  },
  listOverview: {
    tabs: {
      search: 'Search'
    }
  },
  clientSearch: {
    unavailable: 'Search is not available: the search service (Elasticsearch) cannot be reached. Please contact your administrator.',
    loadFailed: 'The list could not be loaded.',
    subTabs: {
      stammdaten: 'Master data',
      relations: 'Client relations',
      dataQuality: 'Data quality'
    },
    clientType: {
      all: 'All',
      person: 'Person',
      company: 'Company'
    },
    filters: {
      clientType: 'Client type',
      addRow: 'Add filter',
      removeRow: 'Remove filter',
      field: 'Field',
      operator: 'Condition',
      value: 'Value',
      connector: {
        and: 'And',
        or: 'Or'
      }
    },
    operators: {
      contains: 'contains',
      notContains: 'does not contain',
      startsWith: 'starts with',
      endsWith: 'ends with',
      equals: 'equals',
      notEquals: 'does not equal',
      greaterThan: 'is greater than',
      lessThan: 'is less than',
      equalsYear: 'equals year (yyyy)',
      beforeYear: 'before year (yyyy)',
      afterYear: 'after year (yyyy)',
      exactDate: 'date (dd.mm.yyyy)',
      isEmpty: 'is empty'
    },
    relations: {
      service: 'Service',
      serviceAll: 'All',
      serviceNone: 'No relation',
      status: 'Relation status',
      acknowledgment: 'Annual receipt',
      contactByPhone: 'Phone contact allowed',
      contactByEmail: 'Email contact allowed',
      contactByLetter: 'Letter contact allowed',
      localAssociation: 'Local association',
      combinationRows: 'Additional services',
      connector: {
        and: 'And',
        or: 'Or',
        not: 'Not'
      }
    },
    dataQuality: {
      criterion: 'Criterion',
      criteria: {
        activeMultipleMemberships: 'Two or more active memberships',
        duplicateMembershipOrDonationRelations: 'Duplicate membership/donation relations',
        missingRelationStatus: 'Missing/unknown relation status',
        missingCustomerNumber: 'Missing customer number',
        missingNextDueDate: 'Missing next due date',
        missingMandateNumber: 'Missing SEPA mandate number',
        missingMandateDate: 'Missing SEPA mandate date',
        duplicateMemberNumber: 'Duplicate member number',
        relationWithoutEndDateNotActive: 'Relation without end date, but status not active',
        relationWithEndDateButActive: 'Relation with end date, but status active'
      }
    },
    columns: {
      lastname: 'Last name',
      firstname: 'First name',
      firma: 'Company',
      zip: 'Zip',
      city: 'City',
      phone: 'Phone'
    },
    fields: {
      anrede: 'Salutation',
      titel: 'Title',
      name: 'Last name',
      vorname: 'First name',
      kategorie: 'Category',
      bankaccountKontoInhaber: 'Account holder',
      abteilung: 'Department',
      kontaktperson: 'Contact person',
      position: 'Position',
      plz: 'Zip',
      ort: 'City',
      strasse: 'Street',
      telefon: 'Phone (private)',
      dienstlich: 'Phone (business)',
      mobil: 'Phone (mobile)',
      email: 'Email',
      gebDatum: 'Date of birth',
      familienstand: 'Marital status',
      sprache: 'Language',
      beruf: 'Profession',
      firma: 'Company',
      firma2: 'Company 2',
      debKonto: 'Debtor account',
      bankaccountKontoBlz: 'Bank code',
      bankaccountKontoNr: 'Account number',
      bankaccountKontoInstitut: 'Bank',
      bemerkung: 'Note',
      confidentialNote: 'Note / confidential',
      anmerkung: 'Remark',
      addField01: 'Free field 1',
      addField02: 'Free field 2',
      additionalAddress: 'Additional address',
      addressStatus: 'Address status',
      fax: 'Fax',
      bankaccountBic: 'BIC',
      bankaccountIban: 'IBAN',
      marketingGroupId: 'Marketing group',
      relationStopDate: 'Contribution stop',
      relationStartDate: 'Membership start date',
      relationEndDate: 'Termination date',
      relationPaymentTypeId: 'Billing period',
      relationPaymentMethodId: 'Payment method',
      relationAnnualSubscription: 'Annual fee',
      relationCustomerNumber: 'Member number',
      prenotificationPassDate: 'Direct debit mandate as of',
      prenotificationPassCheck: 'Direct debit mandate',
      acknowledgment: 'Annual receipt',
      advertiser: 'Referral',
      currentCandidates: 'Referrer name',
      newspaperId: 'Newspaper title',
      newspaperBarrier: 'Newspaper block',
      repatriation: 'Repatriation service',
      repatriationService: 'Flight service',
      dueNotice: 'Termination reason',
      memberPassCheck: 'Membership card',
      memberPassDate: 'Membership card as of',
      bankaccountMandatsnummer: 'SEPA mandate',
      bankaccountMandatsdatum: 'SEPA mandate date',
      terminationPassCheck: 'Termination letter',
      terminationPassDate: 'Termination letter as of',
      partnerRelation: 'Partner relation',
      partnerLastname: 'Partner last name',
      partnerFirstname: 'Partner first name',
      partnerTitle: 'Partner title',
      partnerSalutation: 'Partner salutation',
      partnerStreet: 'Partner street',
      partnerZipcode: 'Partner zip',
      partnerCity: 'Partner city',
      partnerDateOfBirth: 'Partner date of birth',
      welcomePassCheck: 'Welcome letter',
      welcomePassDate: 'Welcome letter as of',
      registerOfficeDate: 'Registration office date'
    }
  },
  clientList: {
    title: 'Client list',
    filters: {
      name: 'Last name',
      vorname: 'First name',
      zip: 'Zip',
      city: 'City',
      street: 'Street',
      marketingGroup: 'Marketing group',
      marketingGroupNone: 'No marketing group found',
      templateLabel: 'Template'
    },
    columns: {
      lastname: 'Last name',
      firstname: 'First name',
      street: 'Street',
      zip: 'Zip',
      city: 'City',
      phone: 'Phone'
    },
    detailNotAvailable: 'The client mask is not available for this module yet.',
    actions: {
      selectedCount: '{count} selected',
      delete: 'Delete',
      labels: 'Labels',
      export: 'Export',
      deleteDialog: {
        title: 'Delete clients',
        deletable: 'The following clients will be deleted:',
        blocked: 'The following clients cannot be deleted:',
        reasonZentrale: 'headquarters with linked companies',
        reasonActiveCourses: 'active or upcoming course participation',
        result: '{succeeded} deleted, {failed} failed'
      },
      labelsDialog: {
        presetLabel: 'Herma templates',
        preset70x36: 'Herma 70×36 mm (24 per sheet)',
        preset70x42: 'Herma 70×42 mm (21 per sheet)',
        preset48x17: 'Herma 48.3×16.9 mm (64 per sheet)',
        fieldsLabel: 'Content',
        fieldAnrede: 'Salutation, title',
        fieldName: 'First name, last name',
        fieldStreet: 'Street',
        fieldZipCity: 'Zip, city',
        fieldFirma: 'Company',
        individualLabel: 'Individual settings',
        marginLeft: 'Left margin',
        marginTop: 'Top margin',
        labelHeight: 'Label height',
        labelWidth: 'Label width',
        fontSize: 'Font size',
        fontAlign: 'Alignment',
        alignLeft: 'Left',
        alignCenter: 'Center',
        alignRight: 'Right',
        colsPerSheet: 'Labels horizontal',
        rowsPerSheet: 'Labels vertical',
        repeatAddress: 'Repeat address',
        onceOnly: 'Print once'
      },
      exportDialog: {
        csv: 'CSV',
        pdf: 'PDF'
      }
    }
  },
  companyList: {
    title: 'Company list',
    filters: {
      name: 'Company',
      firma2: 'Company 2',
      zip: 'Zip',
      city: 'City',
      street: 'Street',
      marketingGroup: 'Marketing group',
      marketingGroupNone: 'No marketing group found',
      templateLabel: 'Template'
    },
    columns: {
      firma: 'Company',
      firma2: 'Company 2',
      debKonto: 'Debitor number',
      street: 'Street',
      zip: 'Zip',
      city: 'City',
      phone: 'Phone'
    },
    detailNotAvailable: 'The client mask is not available for this module yet.',
    actions: {
      selectedCount: '{count} selected',
      delete: 'Delete',
      labels: 'Labels',
      export: 'Export',
      deleteDialog: {
        title: 'Delete companies',
        deletable: 'The following companies will be deleted:',
        blocked: 'The following companies cannot be deleted:',
        reasonZentrale: 'headquarters with linked companies',
        reasonActiveCourses: 'active or upcoming course participation',
        result: '{succeeded} deleted, {failed} failed'
      },
      labelsDialog: {
        presetLabel: 'Herma templates',
        preset70x36: 'Herma 70×36 mm (24 per sheet)',
        preset70x42: 'Herma 70×42 mm (21 per sheet)',
        preset48x17: 'Herma 48.3×16.9 mm (64 per sheet)',
        fieldsLabel: 'Content',
        fieldAnrede: 'Salutation, title',
        fieldName: 'Company, company 2',
        fieldStreet: 'Street',
        fieldZipCity: 'Zip, city',
        fieldFirma: 'Company',
        individualLabel: 'Individual settings',
        marginLeft: 'Left margin',
        marginTop: 'Top margin',
        labelHeight: 'Label height',
        labelWidth: 'Label width',
        fontSize: 'Font size',
        fontAlign: 'Alignment',
        alignLeft: 'Left',
        alignCenter: 'Center',
        alignRight: 'Right',
        colsPerSheet: 'Labels horizontal',
        rowsPerSheet: 'Labels vertical',
        repeatAddress: 'Repeat address',
        onceOnly: 'Print once'
      },
      exportDialog: {
        csv: 'CSV',
        pdf: 'PDF'
      }
    }
  },
  bgListMask: {
    title: 'Employers\' liability insurance association',
    tabs: {
      data: 'BG data',
      online: 'Online registration settings'
    },
    cards: {
      kontakt: 'Address & contact person',
      bank: 'Bank details',
      abrechnung: 'Billing'
    },
    fields: {
      street: 'Street',
      zip: 'Zip',
      city: 'City',
      phone: 'Phone',
      fax: 'Fax',
      mail: 'Email',
      website: 'Website',
      ap_anrede: 'Salutation',
      ap_titel: 'Title',
      ap_name: 'Last name',
      ap_vorname: 'First name',
      kto_institut: 'Bank',
      kto_inhaber: 'Account holder',
      kto_nr: 'Account number',
      kto_blz: 'Bank code',
      kto_iban: 'IBAN',
      kto_bic: 'BIC',
      kto_bemerkung: 'Note',
      debitor_number: 'Debitor number',
      vat_number: 'VAT ID',
      tax_number: 'Tax number',
      cost_center: 'Cost center',
      cost_typ: 'Cost type',
      cost_unit: 'Cost unit',
      revenue_account: 'Revenue account',
      add_field_01: 'Free 1',
      add_field_02: 'Free 2',
      anmerkung: 'Note'
    },
    ibanInvalid: 'Could not resolve IBAN.',
    debitorNumberConflict: 'This debitor number is already used by another BG and a client.',
    onlineRegistration: {
      attachmentToggle: 'Include BG attachment with online registration',
      additionalText: 'Additional text'
    }
  },
  teacherMask: {
    title: 'Teacher',
    noData: 'No entries',
    actions: {
      csvExport: 'CSV export'
    },
    tabs: {
      person: 'Person',
      courses: 'Courses',
      documents: 'Documents'
    },
    cards: {
      stammdaten: 'Master data',
      organisation: 'Organisation',
      lehrscheine: 'Certificates',
      verfuegbarkeit: 'Availability',
      weitereDetails: 'Further details',
      sperrzeiten: 'Blocked periods',
      schulungen: 'Trainings'
    },
    verfuegbarkeit: {
      weekdaysFieldset: 'Weekday availability',
      noDays: 'No weekday availability.'
    },
    certificateAssignments: {
      title: 'Course titles',
      availableTitle: 'Available course titles',
      availableColumn: 'Course title',
      availableInfo: 'All marked course titles are valid for certificates.',
      availableLegendTitle: 'Legend',
      availableLegend: 'Italic entries are blank certificates without proof of qualification.',
      unknownLabel: 'Unknown'
    },
    fields: {
      prefix: 'Salutation',
      firstname: 'First name',
      lastname: 'Last name',
      position: 'Position',
      birthday: 'Date of birth',
      street: 'Street',
      zip: 'ZIP',
      city: 'City',
      phone: 'Phone',
      mobile: 'Mobile',
      fax: 'Fax',
      email: 'E-Mail',
      employer_name: 'Employer',
      employment_relation: 'Employment relation',
      duty_group: 'Function group',
      personnelnumber: 'Personnel number',
      accession: 'Start date',
      wage_types_fee: 'Wage type/fee',
      description: 'Description',
      description2: 'Notes',
      iban: 'IBAN',
      bic: 'BIC',
      weekdays: 'Weekday availability',
      weekdays_notiz: 'Weekday note',
      org_name: 'Name',
      org_city: 'City',
      org_zipcode: 'Zip',
      org_street: 'Street',
      org_phone: 'Phone',
      org_fax: 'Fax',
      org_webpage: 'Website',
      blockadeTitle: 'Title',
      dateFrom: 'From',
      dateTo: 'To',
      available: 'Available',
      notiz: 'Note',
      trainingName: 'Training title',
      trainingNumber: 'Training no.',
      lessonHour: 'Teaching units',
      trainingBegin: 'Start',
      trainingEnd: 'End',
      pointMed: 'Medical points',
      pointPaedag: 'Educational points',
      schoolName: 'School name',
      schoolStreet: 'School street',
      schoolZip: 'School zip',
      schoolCity: 'School city',
      trainingDescription: 'Training description',
      validFrom: 'Valid from',
      validTo: 'Valid to',
      certNumber: 'Number',
      certName: 'Name',
      certDescription: 'Note'
    },
    blockadeFieldsets: {
      dateRange: 'Blocked period from/to',
      weekdays: 'General blocked period on weekdays'
    },
    weekdays: {
      monday: 'Monday',
      tuesday: 'Tuesday',
      wednesday: 'Wednesday',
      thursday: 'Thursday',
      friday: 'Friday',
      saturday: 'Saturday',
      sunday: 'Sunday'
    },
    columns: {
      number: 'Number',
      certName: 'Name',
      validFrom: 'Valid from',
      validTo: 'Valid to',
      leklass: 'Service class',
      isBg: 'BG?',
      blockadeTitle: 'Title',
      dateFrom: 'From',
      dateTo: 'To',
      available: 'Available',
      notiz: 'Note',
      trainingName: 'Training title',
      trainingNumber: 'Training no.',
      lessonHour: 'Teaching units'
    },
    courseColumns: {
      kursnr: 'Course no.',
      leidextcontr: 'Abbreviation',
      kursbez: 'Course title',
      typ: 'Course type',
      date: 'Date',
      dozKost: 'Other costs',
      dozVerg: 'Fee',
      openCourse: 'Open course',
      tooltip: {
        courseNumber: 'Course no.: {courseNumber}',
        module: 'Module: {module}',
        status: 'Course status: {status}',
        settled: 'settled courses',
        unsettled: 'not settled courses',
      },
    },
    courseModules: {
      ktv: 'Courses',
      kifam: 'Family',
      ls: 'Academy',
    },
    coursesTotal: 'Total {year}: {amount} Euro',
    dialogs: {
      addBlockade: 'Add blocked period',
      editBlockade: 'Edit blocked period',
      addTraining: 'Add training',
      editTraining: 'Edit training',
      addCertificate: 'Add certificate',
      editCertificate: 'Edit certificate'
    }
  },
  courseDefaults: {
    data_title: 'Course designation',
    course_amount_title: 'Course amount',
    course_amount_value: 'Amount',
    course_amount_value_extern: 'External amount',
    course_amount_value_hik: 'HIK amount',
    course_amount_default_name_normal: 'Amount',
    course_amount_default_name_extern: 'External',
    course_amount_default_name_hik: 'HIK',
    course_amount_default_Pay: ' €',
    designation: 'Designation',
    type: 'Type',
    cost_type_paid: 'Paid',
    cost_type_free: 'Free',
    cost_type_request: 'On request',
    cost_type_hidden: 'Disabled',
    edit_title: 'Course basic settings',
    search_title: 'Course basic settings',
    search_title_short: 'Search',
    moduleName: {
      ktv: 'Course',
      kifam: 'Family',
      ls: 'Academy'
    },
    moduleTooltip: 'Module: {module}',
    moduleTooltipInvalid: 'Assignment of the course type is not correct',
    moduleFilterTooltip: 'Filter by module',
    moduleFilterAll: 'All',
    linkedDesignationNotFound: 'The course designation linked to this course could not be found.',
    contraction: 'Abbreviation',
    title: 'Course title',
    qualification_skippable: 'Course without qualification proof',
    qualification_skippable_tooltip: 'Course without proof of qualification',
    affects_existing_courses_tooltip: 'Changes take effect immediately on already existing, linked courses.',
    based_on_type: 'Based on course type',
    fee_per_course: 'Course fee gross/EUR',
    vat: 'VAT',
    bg_course_type: 'BG course',
    bg_course_id: 'BG course',
    module: 'Module',
    drkserver_course: 'DRK server course',
    drkserver_course_question: 'DRK server course?',
    drkserver_course_deprecated: '{name} (deleted)',
    lesson_hour: 'Teaching unit',
    lesson_minutes: 'per minutes',
    subscriber_min: 'Participants min.',
    subscriber_max: 'Participants max.',
    time_start: 'Start time',
    time_end: 'End time',
    buha_title: 'Buchhaltung',
    revenue_account: 'Revenue account',
    cost_center: 'Cost center',
    cost_unit: 'Cost unit',
    cost_type: 'Cost type',
    project_number: 'Project number',
    individual_code: 'Individual code',
    notice_internal: 'Note (internal)',
    course_numberformat: 'Auto course number',
    course_number_duplicate: 'Course number already in use',
    numbering_title: 'Course number',
    numbering_dialog_title: 'Course number',
    numbering_dialog_settings_title: 'Course number settings',
    numbering_mode_label: 'Format/Course number',
    numbering_mode_0: 'Default value (from course title)',
    numbering_mode_1: 'Sequence number (format from course title)',
    numbering_mode_2: 'General settings (format + sequence number)',
    numbering_format_group_title: 'Course format',
    numbering_format_label: 'Selection',
    numbering_format_preview_label: 'Format',
    numbering_counter_section_title: 'Sequence number (NN)',
    numbering_type_per_course_type: 'per course type',
    numbering_type_all_designations: 'all course designations',
    numbering_locked_by_general_settings: "Configure course number in 'General settings'.",
    numbering_start_count: 'Start counting',
    numbering_digits: 'Number of digits',
    numbering_digits_tooltip_title: "'Number of digits' with leading zeros.",
    numbering_digits_tooltip_example_2: 'Example: 2 = 01, 02 ...',
    numbering_digits_tooltip_example_5: '5 = 00001, 00002, ...',
    numbering_digits_tooltip_example_7: '7 = 0000001, 0000002, ...',
    last_assigned_course_number: 'Last assigned course number',
    numbering_format_1: 'Course abbreviation/year/seq. no. (KK-YYYY-NN)',
    numbering_format_2: 'Year/course abbreviation/seq. no. (YYYY-KK-NN)',
    numbering_format_3: 'Sequence number (NN)',
    numbering_format_4: 'Year/seq. no. (YYYY-NN)',
    numbering_format_5: 'Course abbreviation/seq. no. (KK-NN)',
    numbering_format_6: 'Year/cost center/seq. no. (YYYY-KS-NN)',
    numbering_format_7: 'Year/individual code/seq. no. (YYYY-IC-NN)',
    numbering_format_8: 'Year/month/cost center/seq. no. (YYYY-MM-KS-NN)',
    numbering_token_yyyy: 'Year (course year)',
    numbering_token_mm: 'Month (course start date)',
    numbering_token_dd: 'Day (course start date)',
    numbering_token_kk: 'Course abbreviation',
    numbering_token_ks: 'Cost center',
    numbering_token_ic: 'Individual code',
    numbering_token_nn: 'Sequence number',
    registration_url: 'Page link',
    link_document: 'Documents link',
    mail_settings_title: 'Mail delivery settings',
    auto_online_registration_with_confirmation_mail: 'Automatic transfer of online registrations with confirmation email?',
    auto_online_registration_with_confirmation_mail_tooltip: 'Fully automatic confirmation email:\n• If “Yes” is selected, incoming online registrations are automatically transferred within 5 minutes and the confirmation email is sent. Between 6 a.m. and 7 p.m.\n• If “No” is selected, you transfer and confirm the online registration manually.',
    mail_bcc_to: 'Mail BCC to',
    mail_bcc_option_empty: '',
    mail_bcc_option_control_clerk: 'DLDB collective mail address',
    mail_bcc_option_collective_ap_dldb: 'DLDB contact person 1 mail',
    mail_reply_address: 'Mail reply address',
    company_registration_participants_receive_confirmation_too: 'Company registration: participants should also receive the confirmation in addition to the contact person',
    company_registration_participants_receive_confirmation_too_tooltip: 'Templates "Scheine":\n- TN certificate A4,\n- TN certificate A5 MONA,\n- TN certificate A6\n... and derivatives of these will be sent to the company as recipients.\n\nRecipients: "Send mail(s)"\nShould the company be displayed?',
    recipient_mail_send_company_visible: "Recipient: 'Send mail(s)' company should be displayed",
    mail_confirmation_attachment: 'Mail confirmation attachment',
    updater_reductions_title: 'Reductions',
    updater_surcharges_title: 'Surcharges',
    updater_category_tooltip_active_marks_title: 'Active markings',
    updater_category_tooltip_changed_letters_title: 'Changed letters',
    updater_category_tooltip_loading: 'Loading...',
    updater_category_tooltip_empty: 'No markings available.',
    template_settings_title: 'Template settings',
    template_settings_edit_title: 'Edit template settings',
    template_source_list_title: 'Templates for this course',
    template_available_letters_title: 'Letter selection',
    template_copy_title: 'Copy template list',
    template_selected_area: 'Area',
    template_letters_adjustment_for_area: '... for',
    template_select_row_hint: 'Please click edit on the left row to display the letter list on the right.',
    template_selection_dialog_title: 'Select template',
    template_category_filter_sz: 'Only self-payer letters are shown (category SZ).',
    template_category_filter_fa: 'Only company letters are shown (category FA).',
    template_category_filter_bg: 'Only BG letters are shown (category BG).',
    template_selection_choose_letter: 'Please select a template.',
    template_selection_saved: 'Template saved successfully',
    template_selection_save_error: 'Error while saving the template',
    template_selection_no_course: 'Saving is not possible: course default has no ID.',
    template_left_subtitle_letters: 'Selection of areas with letter names',
    template_left_subtitle_copy: 'The complete lower list (area & letter name) will be copied to the selection on the right side.',
    template_copy_subtitle: '... after',
    template_table_area: 'Area',
    template_table_directory: 'Directory',
    template_table_letter_id: 'ID',
    template_table_letter_name: 'Letter name',
    template_directory_standard: 'Default letter',
    template_directory_kv: 'KV template',
    template_edit_not_implemented: 'Editing single templates will follow in the next step.',
    updater_dialog_title: 'Course updater',
    updater_tab_fields: 'Fields/sections',
    updater_tab_courses: 'Linked courses',
    updater_tooltip: 'Transfers selected data of this course designation to courses that already exist.',
    updater_description: 'Most changes to a course designation only apply to courses created afterwards. The course updater also transfers selected data to existing courses linked to this designation: choose the data under “Fields/sections” and the courses under “Linked courses”. The current values of these courses are overwritten.',
    updater_dialog_title_context_prefix: 'for',
    updater_dialog_title_with_contraction_and_designation: 'Course updater for {contraction} | {designation}',
    updater_dialog_title_with_contraction: 'Course updater for {contraction}',
    updater_dialog_title_with_designation: 'Course updater for {designation}',
    wizard_title: 'New designation',
    wizard_prev: 'Back',
    wizard_next: 'Next',
    wizard_summary_title: 'Summary',
    wizard_summary_missing_fields_title: 'Missing required fields',
    wizard_validation_required: 'This field is required',
    wizard_validation_places_exceeded: 'The entered seats exceed the available seats ({free})',
    wizard_validation_required_group: 'Please fill in all required fields.',
    wizard_validation_teacher_draft: 'Teacher entry is incomplete. Click "Apply" or clear the input.',
    wizard_saved_success: 'Saved successfully',
    wizard_saved_with_teacher_warnings: '{failed} of {total} teachers could not be saved.',
    wizard_saved_error: 'Error while saving',
    wizard_confirm_save_title: 'Confirm save',
    wizard_confirm_save_message: 'Do you want to save the new designation?',
    wizard_teacher_no_data: 'No data available',
    wizard_teacher_add: 'Apply',
    wizard_teacher_update: 'Apply',
    wizard_teacher_remove: 'Delete',
    teacher_settings_title: 'Teachers',
    teacher_short_label: 'Abbreviation',
    teacher_description_label: 'Description',
    teacher_valid_short_label: 'Valid',
    teacher_valid_from_label: 'Valid from',
    teacher_area_label: 'Area',
    teacher_area_hour: 'Hourly rate',
    teacher_area_course: 'Course rate',
    teacher_area_day_flat: 'Daily flat rate',
    teacher_area_course_flat: 'Course flat rate',
    teacher_amount_label: 'Amount',
    teacher_break_minutes_label: 'Break time',
    wizard_teacher_area_60min: 'Hourly rate (60 min.)',
    wizard_teacher_area_ue: 'Teaching unit',
    wizard_teacher_area_day: 'Daily flat rate (teacher)',
    wizard_teacher_area_flat: 'Course flat rate (teacher)'
  },
  teacher: {
    tabs_templates: 'Templates',
    tabs_teachers: 'Teachers',
    tabs_additional_info: 'Additional info',
    tabs_preview: 'Preview',
    teacher_name: 'Teacher/Name',
    certificate_no: 'Certificate no.',
    valid_from: 'Valid from',
    valid_to: 'Valid to',
    compensation: 'Compensation',
    doz_short: 'Doz',
    courseDays: {
      overviewTitle: 'Teacher overview',
      teacherCount: '{count} teachers',
      noData: 'No teacher days available.',
      showDates: 'Show dates',
      hideDates: 'Hide dates',
      detailsTooltip: 'Details (coming soon)',
      settingsTooltip: 'General settings of the teachers',
      moreOptionsTooltip: 'More options',
      deleteTooltip: 'Remove teachers from course',
      deleteTeacherAction: 'Delete teacher',
      expandTitle: '{count} dates',
      editDialog: {
        title: 'Edit teacher',
        room: 'Room',
        timeRange: 'Start/end',
        teacherFunction: 'Teacher function',
        teacher: 'Teacher',
        applyToAll: 'Teacher for all dates',
        applyToAllInfo: 'The teacher is transferred to all course dates only once or updated with the changed teacher.',
        distance: 'Distance',
        lessonHour: 'UE (teaching units)',
        lessonHourExceedsCourseHint: 'Together with the UE already used, this totals {totalValue} and exceeds the course UE ({courseValue}).',
        lessonHourExceedsCourseTitle: 'UE exceeded',
        lessonHourExceedsCourseMessage: 'The entered UE ({enteredValue}) together with the UE already used ({usedValue}) totals {totalValue}, exceeding the course UE ({courseValue}). Save anyway?',
        lessonHourInfoCourseTotal: 'Total UE in course: {value} units',
        lessonHourInfoUsed: 'Other (dates/teachers): {value} units',
        payment: 'Compensation',
        paymentInfoLoading: 'Compensation is being calculated ...',
        paymentInfoEmpty: 'No compensation preview available.',
        saveSuccess: 'Teacher saved.',
        saveError: 'Teacher could not be saved.',
        otherCharge: 'Other',
        otherChargeDesc: 'Desc.',
        surcharge: 'Surcharge',
        department: 'Department',
        remark: 'Remark'
      },
      letters: {
        teacherCertificateTitle: 'Teachers with a certificate for this course',
        teacherCertificateTooltip: 'Teachers with a certificate for this course',
        noCertificates: 'No matching teacher certificates available.',
        templatesTitle: 'Letter templates for this course',
        selectedTeachers: '{count} teachers selected',
        selectedRecipients: 'Recipient basis: {count} teachers'
      },
      columns: {
        surchargeEuro: 'Surcharge euro',
        otherEuro: 'Other euro',
        distance: 'Distance',
        rounded: 'Settled'
      }
    }
  },
  leftMenu: {
    toggle_menu: 'Toggle menu',
    customer_mask: 'Customer mask',
    customer_mask_search: 'Customer mask search',
    customer_list: 'Customer list',
    company_list: 'Company list',
    customer_export: 'Customer export',
    customer_import: 'Customer import',
    letters_and_emails: 'Letters & emails',
    contact_form: 'Contact form',
    resubmission: 'Resubmission',
    bvw_import: 'BVW import',
    member_mask: 'Member mask',
    member_mask_search: 'Member mask search',
    list_of_members: 'Member list',
    online_registration: 'Online registration',
    sepa_export: 'SEPA export',
    member_import: 'Member import',
    member_export: 'Member export',
    statistic: 'Statistics',
    birthday: 'Birthdays',
    anniversary_list: 'Anniversary list',
    annual_receipt: 'Annual receipt',
    course_overview: 'Course overview',
    course_basic_settings: 'Course basic settings',
    course_master_data: 'Course master data',
    lecturer_days: 'Lecturer days',
    subscriber: 'Participants',
    course_documents: 'Course documents',
    course_dates: 'Course dates',
    course_materials: 'Course materials',
    lecturer: 'Lecturers',
    subscriber_mask: 'Participant mask',
    subscriber_mask_search: 'Participant mask search',
    subscriber_list: 'Participant list',
    bg_list: 'BG list',
    marketing_tool: 'Marketing tool',
    subscriber_import: 'Participant import',
    course_import: 'Course import',
    invoice_journal: 'Invoice journal',
    messages: 'Messages'
  },
  news: {
    dialogTitle: 'Messages',
    close: 'Close',
    empty: 'No messages available',
    defaultTitle: 'New message',
    progress: '{percent} %',
    taskStatus: {
      scheduled: 'Scheduled',
      queued: 'Queued',
      running: 'Running',
      succeeded: 'Succeeded',
      failed: 'Failed',
      cancelled: 'Cancelled',
      timeout: 'Timed out'
    },
    result: {
      mailSummary: '{succeeded} sent, {failed} failed',
      printSummary: '{succeeded} documents created',
      printFailed: '{failed} documents could not be created',
      archiveFailed: 'Errors occurred in {archiveFailed} archive operations.',
      failuresTitle: 'Errors',
      download: 'Download PDF',
      downloadFallbackName: 'Letter.pdf',
      fileUnavailable: 'File no longer available',
      downloadError: 'The file could not be downloaded.'
    }
  },
  queueTaskTrigger: {
    startError: 'Could not start the action.'
  },
  leftTopMenu: {
    user_database: 'User database',
    customer_database: 'Customer database',
    database: 'Database',
    news: 'News',
    tutorial: 'Tutorial',
    help_customer_database: 'Help customer database',
    help_ktv: 'Help KTV',
    help_fmv: 'Help FMV',
    help_ktv_schools: 'Help Academy',
    faq_ktv: 'FAQ KTV',
    faq_privacy: 'FAQ data protection',
    faq_ideas: 'FAQ ideas workshop',
    hotline_number: 'Hotline number',
    service_database: 'Service database',
    drk_member_letter: 'DRK member letter',
    drk_internal: 'DRK internal',
    purchase_portal: 'Purchase portal',
    help: 'Help'
  },
  routes: {
    course_basic_settings: 'Settings',
    letters_mails_breadcrumb: 'Letters&Emails'
  },
  id: 'ID',
  area: 'Area',
  btn: {
    toCompany: 'Open company',
    toZentrale: 'Open parent company',
    save: 'Save',
    close: 'Close',
    apply: 'Apply',
    copy: 'Copy',
    new: 'New',
    add: 'Add',
    update: 'Update',
    delete: 'Delete',
    remove: 'Remove',
    edit: 'Edit',
    yes: 'Yes',
    no: 'No',
    logout: 'Logout'
  },
  courseSubscriber: {
    lettersTitle: 'Letters as email/print',
    overview: 'Participant overview',
    filter: 'Filter',
    appearedCheckbox: {
      locked: 'The participant is already settled, the attendance can no longer be changed.',
      saveError: 'Attendance could not be saved.'
    },
    dialog: {
      addParticipant: 'Add participant',
      addReservationParticipant: 'Reservation participant',
      addReservation: 'Add reservation',
      editParticipant: 'Edit participant',
      editReservation: 'Edit reservation',
      tabGeneral: 'Participant',
      openCustomerMask: 'Open customer record',
      leaveCourseTitle: 'Leave course',
      leaveCourseMessage: 'Do you want to leave the course and jump to the customer record?',
      leaveCourseMessageCompany: 'Do you want to leave the course and jump to the company record?',
      copyParticipantTitle: 'Participant copy {current}/{total}',
      moveToCourse: 'Move/copy participants to course',
      priceChangeConfirmTitle: 'Participant fee already communicated',
      priceChangeConfirmMessage: 'The participant has already been informed about the fee (online registration with payment). Do you still want to change the fee?',
      priceChangeOldValue: 'Previous amount',
      priceChangeNewValue: 'New amount'
    },
    deleteReservation: {
      title: 'Delete reservation',
      message: 'Do you want to remove the reservation?',
      success: 'Reservation deleted',
      error: 'Reservation could not be deleted'
    },
    deleteDialog: {
      title: 'Delete participants',
      message: 'Do you really want to delete the following participants?',
      success: 'Participants deleted successfully',
      error: 'Participants could not be deleted',
      headers: {
        lastname: 'Last name',
        firstname: 'First name',
        city: 'City',
        email: 'Email'
      }
    },
    statusReasons: {
      waitlist: {
        full: 'Course fully booked',
        requirements: 'Requirements not met',
        releasePending: 'Release pending'
      },
      declined: {
        full: 'Course fully booked',
        qualification: 'Missing qualification',
        releaseDenied: 'Release not granted'
      },
      unsubscribed: {
        illness: 'Illness',
        association: 'Association'
      }
    },
    actions: {
      moreOptions: 'More options',
      notAvailable: 'Feature not available yet',
      close: 'Close',
      menu: {
        moveToCourse: 'Move participants to course',
        copyParticipants: 'Copy participants',
        moveToWaitlist: 'Move participants to waitlist',
        moveToDeclined: 'Move participants to declined list',
        moveToUnsubscribed: 'Move participants to unsubscribed',
        moveToParticipants: 'Move participants to participant list',
        markAppeared: 'Mark as appeared',
        delete: 'Delete participants',
        deleteReservation: 'Delete reservation'
      },
      confirm: {
        moveToWaitlist: {
          title: 'Move participants to waitlist',
          message: 'Do you really want to move the following participants to the waitlist?',
          success: 'Participants moved to the waitlist successfully',
          error: 'Participants could not be moved to the waitlist'
        },
        moveToUnsubscribed: {
          title: 'Move participants to unsubscribed',
          message: 'Do you really want to move the following participants to unsubscribed?',
          success: 'Participants moved to unsubscribed successfully',
          error: 'Participants could not be moved to unsubscribed'
        },
        moveToDeclined: {
          title: 'Move participants to declined list',
          message: 'Do you really want to move the following participants to the declined list?',
          success: 'Participants moved to the declined list successfully',
          error: 'Participants could not be moved to the declined list'
        },
        moveToParticipants: {
          title: 'Move participants to participant list',
          message: 'Do you really want to move the following participants to the participant list?',
          success: 'Participants moved to the participant list successfully',
          error: 'Participants could not be moved to the participant list'
        },
        markAppeared: {
          title: 'Mark participants as appeared',
          message: 'Do you really want to mark the following participants as appeared?',
          success: 'Participants marked as appeared successfully',
          error: 'Participants could not be marked as appeared'
        }
      }
    },
    filters: {
      bg: 'BG'
    },
    dateFrom: 'From',
    dateTo: 'To',
    messages: {
      saveSuccess: 'Record saved',
      saveError: 'Record could not be saved',
      selectSingleReservation: 'Please select exactly one reservation.'
    },
    wizard: {
      confirmDuplicateTitle: 'Duplicate warning',
      confirmMasterDataOverwriteMessage: 'This customer already exists with different master data. Saving overwrites the customer\'s master data with the entered data. Save anyway?',
      alreadyInCourseMessage: 'This customer is already registered in this course.',
      noAdditionalFields: 'No additional information is available for this module.',
      savedSuccess: 'Participant saved successfully',
      savedError: 'Participant could not be saved',
      steps: {
        master: 'Master data',
        courseData: 'Course data',
        billingAddress: 'Billing address',
        additional: 'Additional information',
        summary: 'Summary'
      }
    },
    reservationWizard: {
      confirmSaveTitle: 'Save reservation',
      confirmSaveMessage: 'Do you want to save the new reservation?',
      savedSuccess: 'Reservation saved successfully',
      savedError: 'Reservation could not be saved',
      steps: {
        company: 'Company',
        reservation: 'Reservation data',
        notes: 'Notes',
        summary: 'Summary'
      }
    },
    moveDialog: {
      sourceTitle: 'Participants of the current course',
      targetTitle: 'Target courses',
      search: 'Search',
      reset: 'Reset',
      modeLabel: 'Action',
      dragHint: 'Use drag and drop to move or copy rows to a target course.',
      dragSelectionLabel: 'Selected participants:',
      dragPreview: {
        moveTitle: 'Moving participants',
        copyTitle: 'Copying participants'
      },
      confirm: {
        moveTitle: 'Move participants',
        copyTitle: 'Copy participants',
        moveMessage: 'Do you really want to move the following participants to the target course?',
        copyMessage: 'Do you really want to copy the following participants to the target course?',
        targetLabel: 'Target course',
        moveAction: 'Move',
        copyAction: 'Copy'
      },
      noSourceRows: 'No participants available.',
      noTargetRows: 'No target courses found.',
      loadingTargets: 'Loading target courses...',
      modes: {
        move: 'move',
        copy: 'copy'
      },
      fields: {
        internalName: 'Course no.',
        eventName: 'Course name',
        from: 'Course from',
        to: 'to',
        onlyFreePlaces: 'Seats > 0'
      },
      columns: {
        participant: 'Participant',
        reason: 'Reason',
        lastname: 'Last name',
        firstname: 'First name',
        city: 'City',
        email: 'Email',
        eventName: 'Course name',
        internalName: 'Course no.',
        location: 'Location',
        dateRange: 'From/to',
        freeSeats: 'Seats',
        status: 'Status'
      },
      notifications: {
        missingSelection: 'Please select at least one participant first.',
        missingDropRows: 'No participants were detected for transfer.',
        sameCourse: 'Source and target courses are identical.',
        searchError: 'Target courses could not be loaded.',
        transferError: 'Participants could not be transferred.',
        moveSuccess: 'Participants moved successfully.',
        copySuccess: 'Participants copied successfully.'
      }
    },
    tabs: {
      reservations: 'Reservations',
      declined: 'Declined list',
      unsubscribed: 'Unsubscribed'
    },
    columns: {
      bgShort: 'BG',
      places: 'Places',
      payerType: 'Category',
      reservationDate: 'Reservation date',
      statusChangeDate: 'Cancellation date',
      appeared: 'Appeared',
      appearedShort: 'App.'
    },
    fields: {
      payerType: 'Category',
      bgRecipient: 'Employers\' liability insurance (invoice recipient)',
      bgRecipientNoCompany: 'Please select a company for BG participants – the BG is derived from the company.',
      bgRecipientMissing: 'No BG is stored for this company – no BG invoice can be created.',
      bgCompanyRequired: 'A company from the list must be selected for BG participants.',
      appeared: 'Appeared',
      billingType: 'Billing',
      billingPractice: 'Practices and companies',
      billingBg: 'BG participants',
      payment: 'Participant fee',
      paymentTooltip: '- The participant fee can be changed manually.\n- If no fixed amount is stored in the course master data, the amount is taken from the course defaults\n- If the "BG participants" radio button is activated, the participant fee uses the BG rate from the general club data.',
      reduction: 'Reduction',
      noReduction: 'No reduction',
      department: 'Department',
      onlineRegistration: 'Online registration',
      onlineRegistrationTooltip: 'Date of the course online registration',
      reservationDate: 'Reservation date',
      reservationLink: 'Reservation link',
      reservationTooltipPrefix: 'Reservation converted on',
      openReservationLink: 'Open link',
      freeSeatsContext: 'Free seats',
      reservedParticipants: 'Res. participants',
      reservationTotal: 'Res. total',
      module: 'Module',
      moduleTooltip: 'Customers assigned to the FMV module can only be edited in the supporting member administration.',
      company: 'Company',
      companyOptionDebtorNumber: 'Debtor no. {number}',
      contactPerson: 'Contact person',
      remark: 'Remark',
      internalNotice: 'Internal note',
      paypalId: 'PayPal ID',
      paypalTransactionNumber: 'Transaction no.',
      paypalPayerTooltip: 'The PayPal payment was made by the invoice recipient, not by the participant.',
      statusTn: 'Participant status',
      feeType: 'Fee type',
      feeTypeInternal: 'Internal',
      feeTypeExternal: 'External',
      feeTypeHik: 'HIK'
    },
    extra: {
      courseData: 'Course data',
      billingAddress: 'Billing address',
      paymentData: 'Payment data',
      invoiceRecipient: 'Invoice recipient',
      editInvoiceRecipient: 'Alternative invoice recipient',
      additionalData: 'Additional information',
      dog: 'Dog',
      dogSex: 'Sex',
      dogBadge: 'Badge',
      dogBirthday: 'Date of birth',
      dogChipnumber: 'Chip number',
      dogBreeding: 'Breed',
      dogTesteeType: 'Examinee type',
      reservation_room: 'Hotel room',
      subscriberUnits: 'Participant TU',
      contactPerson: 'Contact person',
      orderCode: 'Order no.',
      food: 'Food choice',
      qualification: 'Qualification',
      honorary: 'Honorary',
      member: 'Member',
      health_risks: 'Health risks',
      children: 'Children participation',
      childSelection: 'Children',
      parentRelation: 'Parent relation',
      childOne: 'Child 1',
      childTwo: 'Child 2',
      optional: 'optional',
      childAgeTooltip: 'Today, the child is {ageYears} years and {ageMonths} months old.',
      childAgeWarningTooltip: 'At the course date, the child is older than {limitYears} years and {limitMonths} months.',
      showAdditionalInformation: 'Show additional information',
      hideAdditionalInformation: 'Hide additional information',
      no_data: 'No data',
    },
    legend: {
      title: 'Legend',
      reservation: 'Marked on the left: participant from reservation',
      childAgeWarning: 'Child of participant is older than 15 years and 6 months'
    }
  },
  courseDocuments: {
    lettersTitle: 'Letters as email/print',
    selfPayer: 'Self-payer',
    tabs: {
      participants: 'Participants',
      teachers: 'Teachers',
      documents: 'Documents'
    },
    viewGroups: 'Recipients',
    viewAllParticipants: 'All participants',
    participantsTitle: 'Participants',
    archiveTitle: 'Archive',
    participantsGroup: 'Company / Self-payer',
    participantCount: 'PA',
    bgCount: 'BG',
    archiveLetterName: 'Last printed letters',
    archiveSentBy: 'Sent by',
    archiveDate: 'Date',
    archiveReceiver: 'Recipients',
    unknownCompany: 'Company (unknown)',
    noGroups: 'No participants available.',
    noHistory: 'No data available.',
    downloadLetter: 'Download file',
    downloadError: 'File could not be downloaded.',
    historyErrors: {
      title: 'The following errors occurred:',
      recipient: 'Error for {name}: {error}',
      bundle: 'Error while merging: {error}',
      downloadHint: 'Click to download the errors as CSV.'
    },
    documentsTitle: 'Documents',
    documentName: 'Document',
    documentComment: 'Comment',
    documentUploadDate: 'Uploaded at',
    noDocuments: 'No documents available.',
    uploadDocument: 'Upload document',
    uploadDialogTitle: 'Upload document',
    uploadFile: 'Select file',
    uploadErrorCourse: 'Please select a course first.',
    deleteConfirmMessage: 'Delete document?',
    downloadDocumentError: 'Document could not be downloaded.'
  },
  annualReceipt: {
    title: 'Annual receipts',
    filters: {
      year: 'for the year',
      clientType: 'Company/person',
      person: 'Person',
      company: 'Company',
      name: 'Name',
      customerNumber: 'Member no.',
      service: 'Membership type',
      relationStatus: 'Relation status',
      acknowledgment: 'Annual receipt',
      repatriation: 'Repatriation service',
      localAssociation: 'Local association',
      localAssociationNone: 'none',
      addressStatus: 'Address status',
      notice: 'Note',
      amountFrom: 'Payment from',
      amountTo: 'to',
      showReceipted: 'show already receipted'
    },
    columns: {
      customerNumber: 'Customer number',
      name: 'Name',
      acknowledgment: 'Annual receipt',
      paymentCount: 'Payments',
      amount: 'Amount'
    },
    summary: '{count} customers, total {amount}',
    loadError: 'The annual receipts could not be loaded.',
    removeReceipt: {
      tooltip: 'Remove receipt',
      title: 'Remove receipt',
      message: 'Do you really want to remove the receipt(s) of "{name}" for {year}?',
      cancel: 'Cancel',
      success: 'The receipt was removed.',
      error: 'The receipt could not be removed.'
    },
    dispatch: {
      titlePrint: 'Print donation receipts',
      titleMail: 'Mail donation receipts',
      letter: 'Letter',
      scopeSelected: 'Selected members ({count})',
      scopeAll: 'All hits ({count})',
      originalHint: 'The donation receipts for {year} are created as originals. The listed contributions are receipted once the dispatch to the member succeeded.',
      copyHint: 'The contributions are already receipted: the donation receipts for {year} are created as copies.',
      print: 'Print',
      mail: 'Mail',
      filename: 'Donation_receipts_{year}.pdf',
      queued: 'The job was started. Progress and result are shown under "Messages".',
      error: 'The dispatch could not be started.'
    }
  },
  invoiceJournal: {
    dispatch: {
      empty: 'No entries',
      mailed: 'Invoice sent by e-mail',
      printed: 'Invoice printed',
      exported: 'Invoice exported as file',
      tabs: { amounts: 'Amounts', dispatch: 'Dispatch' },
      columns: { date: 'Date', time: 'Time', mail: 'E-mail address', name: 'Name', letter: 'Letter template', user: 'User', lastExport: 'Last exported on' }
    },
    creditNoteFor: 'Credit note for {number}',
    courseJump: {
      open: 'Open course',
      confirm: 'The course {number} will be opened. Do you want to continue?'
    },
    sellerData: {
      title: 'Organisation data',
      missing: 'Mandatory e-invoice value missing',
      menuMissing: 'Missing for the e-invoice:',
      missingHint: '{count} mandatory values of the e-invoice are missing. They are marked red below.',
      openAssociationData: 'Open association data',
      openAssociationDataConfirm: 'The association data open in a new page. Do you want to continue?',
      loadError: 'The organisation data could not be loaded.',
      groups: {
        organisation: 'Organisation',
        association: 'Tax data',
        bank: 'Bank account',
        contact: 'Case worker'
      },
      maintainedIn: {
        organisation: 'Can be added or changed in the user administration (organisation data), the level in the association data.',
        association: 'Can be added or changed in the association data.',
        bank: 'Can be added or changed in the association data (main bank of the module).',
        contact: 'Can be added or changed in the user administration.'
      },
      fields: {
        organisation: { level: 'Level', name: 'Name', street: 'Street', zipcode: 'Postcode', city: 'City', phone: 'Phone', email: 'E-mail' },
        association: { sales_tax: 'VAT ID', tax_number: 'Tax number' },
        bank: { iban: 'IBAN', bic: 'BIC' },
        contact: { name: 'Name', phone: 'Phone', email: 'E-mail' }
      }
    },
    collectiveInvoice: {
      selection: 'Selection',
      dateFrom: 'Course period from',
      dateTo: 'to',
      invalidDate: 'Please enter a valid date (DD.MM.YYYY).',
      dateToBeforeFrom: 'The "to" date must not be before the "from" date.',
      payer: {
        bg: 'Employers\' liability insurance (BG)',
        company: 'Company'
      },
      payerOption: '{label} ({count} participants)',
      noPayers: {
        bg: 'No BG has open participants in the selected period.',
        company: 'No company has open participants in the selected period.'
      },
      hint: {
        bg: 'Only participants who attended, are not billed yet and whose company has the selected BG stored are included.',
        company: 'Only participants of the selected company who attended and are not billed yet are included (without BG participants).'
      },
      noParticipants: 'No participants available, so no invoice can be created!',
      create: 'Add to invoice journal',
      created: 'The collective invoice was added to the invoice journal.',
      createdWithSkipped: 'The collective invoice was added to the invoice journal. {count} participants were no longer open and were not included.',
      createError: 'The collective invoice could not be created.'
    },
    interfaceExport: {
      title: 'Interface export – {type}',
      tabs: {
        exports: 'Exports',
        settings: 'Settings'
      },
      start: 'Start export',
      startAction: 'Export {type}',
      scopeSelected: 'Selected invoices ({count})',
      scopeAll: 'All not yet exported invoices of the current filter',
      unsavedSettings: 'The settings have unsaved changes. The export only uses saved settings.',
      history: 'History',
      historyEmpty: 'No exports yet.',
      download: 'Download',
      delete: 'Delete export file',
      deleteConfirm: 'Really delete export file "{name}"?',
      columns: {
        created: 'Date',
        filename: 'File',
        user: 'User',
        size: 'Size'
      },
      messages: {
        created: 'Export created ({count} invoices).',
        createError: 'The export could not be created.',
        historyError: 'The export history could not be loaded.',
        downloadError: 'The export file could not be downloaded.',
        deleted: '{name} was deleted.',
        deleteError: 'The export file could not be deleted.'
      }
    },
    tabs: {
      unbooked: 'Not booked',
      archiveRecent: 'Booked 0-2 years',
      archiveOld: 'Archive + 2 years'
    },
    subTabs: {
      overview: 'Overview',
      booking: 'Book',
      singleInvoice: 'Single invoice'
    },
    filters: {
      invoiceNumber: 'Invoice number',
      type: 'Billing type',
      debtorNumber: 'Debtor number',
      courseNumber: 'Course number',
      moreFilters: 'More filters',
      dateFrom: 'Booking from',
      dateTo: 'Booking to'
    },
    list: {
      title: 'Unbooked invoices',
      empty: 'No unbooked invoices available.'
    },
    groups: {
      invoice: 'Invoice',
      recipient: 'Recipient',
      course: 'Course',
      internal: 'Internal',
      booked: 'Booked'
    },
    columns: {
      invoiceNumber: 'Inv. no.',
      mailTo: 'Mail to',
      printed: 'Printed',
      exported: 'Export',
      exportDate: 'Export date',
      bookedBy: 'Clerk',
      type: 'Type',
      created: 'Created',
      bookingDate: 'Booked',
      debtorNumber: 'Debtor no.',
      recipient: 'Invoice recipient',
      category: 'Cat.',
      courseNumber: 'Course no.',
      courseTitle: 'Course title',
      participants: 'Part.',
      total: 'Total',
      courseStart: 'Course from',
      courseEnd: 'Course to',
      costCenter: 'Cost center',
      revenueAccount: 'Ledger account',
      lastName: 'Last name',
      firstName: 'First name',
      fee: 'Participant fee',
      vat: 'VAT',
      lineTotal: 'Total'
    },
    pdfStatus: {
      legendTitle: 'Legend',
      pending: 'Booked, PDF not created yet',
      failed: 'PDF creation failed'
    },
    actions: {
      showSellerData: 'Organisation data',
      moreOptions: 'More actions',
      discard: 'Delete/discard',
      bookNow: 'Book now',
      previous: 'Previous invoice',
      next: 'Next invoice',
      freeInvoice: 'Free invoice',
      collectiveInvoice: 'Collective invoice',
      bgCollectiveInvoice: 'BG collective invoice',
      companyCollectiveInvoice: 'Company collective invoice',
      cancelInvoice: 'Cancellation',
      interfaceExport: 'Interface export'
    },
    eInvoiceCheck: {
      title: 'E-invoice incomplete',
      intro: 'The following mandatory values are missing for the e-invoice:',
      hint: 'Please enter these values before booking. If you book anyway, the e-invoice will be faulty and the recipient may not be able to process it.',
      bookAnyway: 'Book anyway'
    },
    bookConfirm: {
      title: 'Book invoice',
      message: 'Are you sure you want to book the invoice "{title}" now? The invoice number will be assigned and the invoice can no longer be edited afterwards.',
      faultyEInvoice: 'Attention: mandatory values are missing, the e-invoice will be created faulty.'
    },
    discard: {
      title: 'Delete/discard invoice',
      messageDraft: 'Delete the invoice draft "{title}" permanently? The participants\' billing state is reset.',
      messageLegacy: 'Discard the invoice "{title}"? It is cancelled, open payments are removed and the participants\' billing state is reset.',
      deleted: 'The invoice draft was deleted.',
      cancelled: 'The invoice was discarded.',
      error: 'The invoice could not be deleted/discarded.'
    },
    cancel: {
      title: 'Cancellation note',
      selected: '{count} invoice(s) selected:',
      confirm: 'Please confirm the cancellation now!',
      hint: 'A credit note is created for every invoice (PDF via "Print"); paid course payments are cancelled and credited, the participants\' billing state is reset.',
      action: 'Cancel invoice',
      noSelection: 'Select one or more invoices that are not cancelled yet!',
      freeCreditNote: 'A free credit note cannot be cancelled!',
      notCancellable: 'This invoice is already cancelled or a credit note and cannot be cancelled.',
      success: '{count} invoice(s) cancelled.',
      failed: '{number}: {message}',
      error: 'The invoice could not be cancelled.'
    },
    archive: {
      title: {
        recent: 'Booked invoices of the last 2 years',
        older: 'Booked invoices older than 2 years'
      },
      mailStatus: {
        sent: 'yes',
        mails: 'Mail to:',
        mail: '{mail} ({name}) sent: {datetime}',
        errors: 'Dispatch errors:',
        error: '{datetime} {error}'
      },
      csvNoSelection: 'Select one or more invoices!',
      csvError: 'The CSV export failed.',
      empty: 'No booked invoices available.',
      recreatePdf: 'Re-create PDF',
      pdfMissing: 'The filed PDF of this invoice was not found.',
      pdfMissingChooseTemplate: 'The filed PDF of this invoice was not found and its original letter template no longer exists.',
      pdfMissingDownload: 'The filed PDF of this invoice was not found. Please re-create it via "Re-create PDF".',
      downloadInvoice: 'Download invoice',
      noPdf: 'No PDF is filed for this invoice.',
      print: 'Print',
      notPrintableDiscarded: 'Discarded invoice data cannot be printed.',
      mail: 'Send by mail',
      warnings: {
        recipient_deleted: 'The invoice recipient no longer exists. The invoice PDF was filed in its document storage anyway.'
      },
      letterDialog: {
        printTitle: 'Print invoice',
        template: 'Letter template',
        templatePreview: 'Letter template / Preview',
        noTemplates: 'There is no suitable letter template for this invoice.',
        attachment: 'Attachment',
        printAction: 'Print',
        filedPdf: 'A PDF has already been created for this invoice: {filename} – created on {created} by {user}. No new PDF is created.',
        filedPdfWithoutUser: 'A PDF has already been created for this invoice: {filename} – created on {created}. No new PDF is created.',
        originalTemplate: 'previous template',
        previewLoading: 'Loading preview …',
        previewEmpty: 'There is no preview for this letter template.',
        printed: 'The invoice PDF has been created and filed.',
        printError: 'The invoice PDF could not be created.',
        mailAction: 'Send',
        tabs: {
          template: 'Letter template',
          preview: 'Preview'
        }
      },
      mailDialog: {
        title: 'Send invoice by mail',
        runTitle: 'Invoice {number} by mail',
        queued: 'The mail dispatch has been queued.',
        sendError: 'The invoice could not be sent by mail.',
        previewEmpty: 'There is no preview for this selection.',
        subject: 'Subject',
        variables: 'Variables',
        mailTo: 'Email to',
        name: 'Name',
        bcc: 'BCC',
        replyTo: 'Reply to',
        invoiceAddress: 'Invoice address/mail',
        notMailableBg: 'Invoices to an employers\' liability insurance association are not sent by mail.',
        notMailableStorno: 'Cancelled invoices are not sent by mail.',
        pdfNotPrinted: 'No PDF invoice can be sent because the invoice has not been printed yet.',
        attachmentPdf: 'PDF invoice',
        attachmentXml: 'E-invoice (XML)',
        attachmentPdfInfo: 'The printed PDF invoice with embedded e-invoice (ZUGFeRD): readable PDF and machine-readable XML data in one file.',
        attachmentXmlInfo: 'Only the e-invoice as XML file (XRechnung) for automatic processing by the recipient, e.g. in their accounting software. It contains no readable PDF and can only be sent by mail.',
        fileName: 'File name',
        tabs: {
          recipient: 'Recipient',
          text: 'Mail text',
          recipientText: 'Recipient/Text'
        },
        vars: {
          recipientFirstName: 'Recipient first name',
          recipientLastName: 'Recipient last name',
          courseName: 'Course name',
          courseNumber: 'Course number',
          courseDate: 'Course date',
          typedOrganisation: 'Typed organisation name',
          invoiceNumber: 'Invoice number'
        }
      }
    },
    booking: {
      noSelection: 'Please select an invoice in the overview.',
      noParticipants: 'No participants available.',
      sumTotal: 'Total sum',
      sections: {
        recipient: 'Recipient',
        booking: 'Booking',
        participantFees: 'Participant fees',
        additionalItems: 'Additional items',
        invoiceTotal: 'Invoice total'
      },
      fields: {
        alternativeName: 'Invoice address name',
        category: 'Category',
        invoiceSum: 'Invoice sum'
      }
    },
    messages: {
      itemsSaveError: 'The items could not be saved.',
      recipientSaveError: 'The invoice recipient could not be saved.',
      notAvailable: 'Not available yet',
      downloadError: 'The PDF could not be downloaded.',
      loadError: 'Data could not be loaded.',
      bookingError: 'The invoice could not be booked.',
      notFound: 'The invoice was not found.',
      conflict: 'The invoice is already being booked or has already been booked.',
      invalidTemplate: 'The selected letter template is not allowed for this invoice.',
      booked: 'Invoice {number} was created successfully',
      noFurtherInvoices: 'There are no further unbooked invoices.'
    }
  },
  lettersPanel: {
    additionalInformation: 'Additional information',
    pageTnTitle: 'Certificate(s) per participant',
    pageTnLabel: 'Number of certificates per participant',
    templatesPlaceholder: 'Template integration will be added in the next step.',
    previewPlaceholder: 'Preview integration will be added in the next step.',
    previewMissingSelectionTitle: 'Missing selection',
    previewMissingTemplate: 'Please select at least one template.',
    previewMissingTeacher: 'Please select at least one teacher.',
    previewMissingParticipant: 'Please select at least one participant.',
    tabTemplates: 'Templates',
    tabBrief: 'Letter',
    tabTeachers: 'Teachers with course certificate',
    tabRecipients: 'Participants',
    tabPreview: 'Preview',
    previewSelectionTitle: 'Current preview selection',
    previewTemplateLabel: 'Template',
    previewTeachersLabel: 'Teachers',
    previewParticipantsLabel: 'Participants',
    previewTeachersLabelShort: 'Teach.',
    previewParticipantsLabelShort: 'Part.',
    previewLoading: 'Loading preview ...',
    previewNoDocuments: 'No preview pages could be generated.',
    previewRefresh: 'Reload preview',
    previewPageLabel: 'Page',
    previewPreviousPage: 'Previous page',
    previewNextPage: 'Next page',
    previewImageAlt: 'Template preview',
    previewImageUnavailable: 'The template preview could not be loaded.',
    print: 'Print',
    sendMail: 'Send as mail',
    previewTabIcon: 'Preview',
    previewDialogTitle: 'Preview',
    dispatchRecipients: 'Recipients ({count})',
    reservationDispatchHint: 'Every selected company receives its own reservation with its own entry link.',
    mixedReservationWarning: 'Reservations and participants are selected together: the reservation letter is created for the reservations only, every other letter for the participants only.'
  },
  lettersMails: {
    tabLetters: 'Letters',
    tabRecipients: 'Recipients',
    tabAttachments: 'Attachments',
    comingSoon: 'This feature is coming later.',
    recipients: {
      none: 'no recipients',
      count: '{count} recipients',
      nameColumn: 'Name',
      empty: 'Select entries in a course or teacher list and open Letters & Emails.',
      remove: 'Remove recipient',
      removeConfirmTitle: 'Remove recipient',
      removeConfirm: 'Do you want to remove this recipient?',
      openCustomer: 'Open customer',
      openCustomerTitle: 'Open customer record',
      openCustomerConfirm: 'Would you like to open the customer record?',
      openTeacher: 'Open teacher',
      openTeacherTitle: 'Open teacher record',
      openTeacherConfirm: 'Would you like to open the teacher record?'
    },
    attachments: {
      none: 'no mail attachments',
      one: '1 mail attachment',
      count: '{count} mail attachments',
      empty: 'No attachments have been added.',
      add: 'Add attachments',
      remove: 'Remove attachment',
      hint: 'PDF, PNG and JPEG files; 2 MB total maximum.',
      rejected: 'At least one file has an invalid format or exceeds the 2 MB total limit.'
    },
    recipientTransfer: {
      title: 'Use recipients',
      courseConfirm: 'Use {count} recipients from the selected courses in Letters & Emails?',
      teacherConfirm: 'Use {count} selected teachers in Letters & Emails?',
      clientConfirm: 'Use {recipient} as a recipient in Letters & Emails?',
      selectionConfirm: 'Use {count} selected recipients in Letters & Emails?',
      noSelection: 'Please select at least one entry first.',
      noRecipients: 'No recipients were found for the selection.',
      confirm: 'Use recipients'
    },
    recipientCollector: {
      title: 'Recipients',
      widgetTooltip: 'Recipient list for the letters',
      addButtonTooltip: 'Add to recipient collection',
      addedOne: 'Added to the recipient collection.',
      addedMultiple: '{count} recipients added to the recipient collection.',
      alreadyAdded: 'Already in the recipient collection.',
      removeTooltip: 'Remove from collection',
      applyFromListTooltip: 'Apply from recipient list',
      confirmDialogTitle: 'Apply recipient collection',
      confirmDialogMessage: 'You have {count} recipients in your collection. Would you like to add them to the existing letter recipients, or replace the letter recipients entirely with the collection?',
      confirmDialogAdd: 'Add',
      confirmDialogReplace: 'Replace entirely',
      confirmDialogDismiss: 'Cancel'
    },
    searchLabel: 'Search template',
    searchScopeTooltip: 'Only letter templates for the “{module}” module are searched and displayed.',
    searchScopeModules: {
      kdb: 'KDB',
      fmv: 'FMV',
      ktv: 'Courses',
      ls: 'Academy',
      kifam: 'Family'
    },
    backToTree: 'Back to tree',
    noSearchResults: 'No matches found.',
    rename: 'Rename',
    newFolder: 'New folder',
    visibility: 'Sharing',
    moveTo: 'Move to …',
    renameDialogTitle: 'Rename',
    renameLabel: 'Name',
    renameSuccess: 'The rename was saved.',
    newFolderDialogTitle: 'New folder',
    folderNameLabel: 'Name',
    folderDescriptionLabel: 'Description',
    newFolderSuccess: 'The folder was created.',
    visibilityDialogTitle: 'Sharing',
    visibilityPrivate: 'Only for me',
    visibilityOrg: 'For everyone in my organisation',
    visibilitySuccess: 'The sharing setting was changed.',
    deleteDialogTitle: 'Delete',
    deleteConfirmFolder: 'Do you really want to delete this folder?',
    deleteConfirmLetter: 'Do you really want to delete this letter?',
    deleteFolderNotEmptyWarning: 'This folder is not empty and is still used by the following modules:',
    deleteFolderNotEmptyConfirm: 'Do you want to delete the folder anyway?',
    deleteSuccess: 'The entry was deleted.',
    moveDialogTitle: 'Move to …',
    moveTargetHint: 'Select a target folder.',
    moveConfirmButton: 'Move',
    moveSuccess: 'The entry was moved.',
    actionError: 'The action could not be completed.',
    lastModifiedAt: 'Last edited on {date}',
    noDescription: '<no description>',
    derivedFrom: 'derived from {name}',
    usesLayout: 'uses layout "{layout}" with {configType} configuration',
    letterSpecificConfig: 'letter-specific',
    defaultConfig: 'default',
    emptyEditorPlaceholder: 'Select a letter on the left.',
    readOnlyNotice: 'This template cannot be edited.',
    customCopyBadge: 'Derived',
    savedAsCopyNotice: 'This template was saved as your own copy in the "KV-Vorlagen" folder.',
    saveSuccess: 'The letter was saved.',
    previewUnsavedNotice: 'The preview shows the last saved version. Unsaved changes are only reflected after saving.',
    sendNotAvailable: 'Sending is not available yet until recipient selection is implemented.',
    send: {
      dialogTitle: 'Send email',
      recipientCount: 'The email will be sent to {count} recipients.',
      campaignLabel: 'Create with campaign (optional)',
      noRecipients: 'No recipients are selected.',
      mailToMe: 'Mail to me',
      mailToMeDialogTitle: 'Send mail to me',
      mailToMeInfo: 'The email of the first recipient is sent to your own email address and is not filed.',
      donationReceiptHint: 'Note: please create donation receipts via the annual receipt. Documents created here are marked as copy.'
    },
    dispatch: {
      titleMail: 'Email dispatch: {name}',
      titlePrint: 'PDF creation: {name}',
      queued: 'The job has been started. Progress and result can be found under "Messages".'
    },
    print: {
      dialogTitle: 'Create PDF',
      filenameLabel: 'Filename',
      defaultFilename: 'Letter'
    },
    variablesButton: 'Variables',
    widgetConfigSaved: 'The widget configuration was saved.',
    saveAsTemplate: {
      dialogTitle: 'Save template',
      hint: "Please enter the name under which the template should be saved in 'My templates'.",
      nameLabel: 'Name',
      modulesLabel: 'Modules',
      visibilityLabel: 'Visibility',
      descriptionLabel: 'Description',
      moduleLabels: {
        kdb: 'Customers',
        fmv: 'Supporting members',
        ktv: 'Courses',
        ls: 'Academy',
        kifam: 'Family'
      }
    },
    saveOverwriteConfirm: {
      dialogTitle: 'Save template',
      message: "Apply the change to the template, or save a new template in 'My templates'?",
      applyButton: 'Apply',
      newTemplateButton: 'New template',
      cancelButton: 'Cancel'
    },
    widget: {
      tnList: {
        title: 'Widget: Participant list',
        columnName: 'Column name',
        order: 'Order',
        moveUp: 'Move up',
        moveDown: 'Move down',
        minList: 'Minimum row count',
        addList: 'Extra trailing rows'
      },
      uwtBank: {
        title: 'Widget: Bank transfer slip',
        receiptPosition: 'Receipt position',
        fillOut: 'Fill in details',
        fillPayment: 'Fill in amount',
        fillRngNumber: 'Fill in receipt number',
        left: 'Left',
        right: 'Right',
        yes: 'Yes',
        no: 'No'
      },
      barcode: {
        title: 'Widget: Barcode',
        typeLabel: 'Barcode type',
        type39: 'Type 39',
        type128: 'Type 128'
      },
      stamp: {
        title: 'Widget: Stamp',
        uploadLabel: 'Choose image',
        height: 'Height (mm)',
        width: 'Width (mm)',
        leftOffset: 'Left/right offset (mm)',
        topOffset: 'Top/bottom offset (mm)'
      },
      invoiceSummary: {
        title: 'Widget: VAT summary',
        showFreeText: 'Show § 4 notice (only when exclusively 0% VAT)'
      },
      fmvContribution: {
        title: 'Widget: Contribution list',
        refundLabel: 'Waiver of expense reimbursement',
        refundYes: 'Yes',
        refundNo: 'No',
        addPageLabel: 'Attachment behavior',
        addPageAlways: 'Always attach',
        addPageNoneOnSingle: 'No attachment for a single payment per year',
        addPageBlankOnSingle: 'Insert a blank attachment page for a single payment per year'
      },
      membercard: {
        title: 'Widget: Membership card',
        airService: 'Show air rescue service phone number',
        ovName: 'Show local association name'
      },
      emailSignature: {
        title: 'Widget: Email signature',
        sourceLabel: 'Sender source',
        sourceUser: 'User',
        sourceBvw: 'BVW',
        sourceDldb: 'DLDB',
        sourceManual: 'Manual',
        bvwUserLabel: 'BVW contact',
        collectiveAddress: 'Collective email',
        manualSection: {
          name: 'Name',
          function: 'Function',
          level: 'Level',
          organisation: 'Organisation',
          street: 'Street',
          city: 'ZIP, city',
          phone: 'Phone',
          fax: 'Fax',
          email: 'Email'
        }
      }
    },
    moreOptions: {
      button: 'More options',
      layouts: 'Layouts',
      emailEditor: 'Email editor'
    },
    layout: {
      dialogTitle: 'Layout',
      nameColumn: 'Name',
      descriptionColumn: 'Description',
      configuratorTitle: 'Configurator',
      settingColumn: 'Setting',
      valueColumn: 'Value',
      useDefaultToggle: "Use the layout's default configuration",
      applyBtn: 'Apply',
      previewBtn: 'Preview',
      saveSuccess: 'The layout was applied.',
      lastModifiedAt: 'Last changed on {date}',
      pageNumber: {
        title: 'Page number',
        label: 'Show page number'
      },
      header: {
        title: 'Margins (from page 2)',
        firstPageOnly: 'narrow margins (no logo)',
        smallOnOtherPages: 'smaller top margin (may show logo)'
      },
      barcode: {
        title: 'Barcode',
        show: 'show in footer',
        typeLabel: 'Type',
        type39: 'Type 39',
        type128: 'Type 128'
      },
      logo: {
        title: 'Logo(s)',
        visible: 'show',
        fromPage: 'per/from page',
        fromPageTip: 'per page = 1,3,4 (comma separated) — from page = 2- (number, dash) — page range = 2-3',
        rightVariant: 'Right logo',
        rightUpload: 'Upload right logo',
        leftShow: 'Show left logo',
        leftUpload: 'Upload left logo',
        automatic: 'automatic (DRK/BRK)',
        uploadOption: 'Upload'
      },
      jrkHeaderText: {
        title: 'JRK header text',
        label: 'Header text'
      }
    },
    email: {
      dialogTitle: 'Email editor',
      subjectLabel: 'Subject',
      previewBtn: 'Preview',
      saveBtn: 'Save',
      saveSuccess: 'The email template was saved.'
    }
  },
  courseTermine: {
    headerGroups: {
      termin: 'Date',
      dozenten: 'Lecturer',
      kursort: 'Venue'
    },
    format: {
      presence: 'In person',
      hybrid: 'Hybrid',
      online: 'Online'
    },
    venueType: {
      kv: 'Course at KV',
      online: 'online (KV address)',
      firmaClosed: 'Closed company course',
      firmaExternal: 'Course at company'
    },
    bulk: {
      menuLabel: 'Bulk actions',
      changeRoom: 'Change room',
      changeTeacher: 'Change teacher',
      changeVenue: 'Change venue',
      appliesToCount: 'Applies to {count} selected dates'
    },
    columns: {
      date: 'Date',
      day: 'Day',
      from: 'From',
      to: 'To',
      format: 'Format',
      teacherName: 'Lecturer / Name',
      venue: 'Venue',
      site: 'Site',
      street: 'Street',
      zip: 'ZIP',
      city: 'City',
      room: 'Room'
    },
    dialog: {
      addTitle: 'Date',
      editTitle: 'Edit date',
      seriesTitle: 'Create date series',
      dateStart: 'Start date',
      dateEnd: 'Ends on',
      endCount: 'Ends after N dates',
      frequency: 'Frequency',
      intervalCount: 'Every (count)',
      weekday: 'Weekdays',
      seriesHint: 'All dates of the series are individual entries in the table view. Initially they share the same teacher and venue; you can change them per single date by editing it.'
    },
    confirm: {
      deleteTitle: 'Delete date',
      deleteMessage: 'Do you really want to delete the selected dates? | Do you really want to delete this date? | Do you really want to delete these {count} dates?'
    }
  },
  courseTerminWizard: {
    title: 'Create dates',
    step_termine: 'Dates',
    step_zuordnung: 'Assignment',
    step_summary: 'Review',
    toolbar: {
      addSingle: 'Add single date',
      addSeries: 'Add date series'
    },
    table: {
      count: '{count} dates',
      empty: 'No dates yet. Add a single date or a date series.',
      teacherPlaceholder: 'Select lecturer'
    },
    mass: {
      title: 'Bulk assignment',
      hint: 'Set venue, room, lecturer or format for several dates at once. Select rows to change only those.',
      apply: 'Apply',
      scopeAll: 'To all {count} dates',
      scopeSelected: 'To {count} selected'
    },
    series: {
      title: 'Add date series'
    },
    datum: {
      startDate: 'Start date',
      endDate: 'Ends on',
      endCount: 'Ends after N dates',
      every: 'Every',
      weekdays: 'Weekdays'
    },
    unit: {
      days: 'days',
      weeks: 'weeks',
      months: 'months'
    },
    weekday: {
      mon: 'Mon',
      tue: 'Tue',
      wed: 'Wed',
      thu: 'Thu',
      fri: 'Fri',
      sat: 'Sat',
      sun: 'Sun'
    },
    summary: {
      overview: 'Overview',
      dateCount: 'Number of dates'
    },
    confirm_title: 'Save dates',
    confirm_message: 'Do you want to create {count} dates?',
    saved_success: 'Dates created',
    saved_error: 'Error while creating the dates',
    validation: {
      required: 'Please fill in the required fields.',
      dateRequired: 'Please provide a valid date for every date row.',
      timeRequired: 'Please provide a start and end time (HH:MM) for every date.',
      endRequired: 'Please provide an end date or a count.',
      noDates: 'No dates could be generated from the input.',
      noCourse: 'No course loaded.'
    }
  },
  marketingTool: {
    companies: {
      title: 'Companies',
      search: 'Search',
      empty: 'No companies found',
      needsRefresh: 'Refresher required',
      noRefresh: 'No refresher required'
    },
    company: {
      title: 'Company details',
      none: 'No company selected',
      addressee: 'Contact person',
      addresseeCompany: 'Company',
      mainContact: 'Main contact',
      fields: {
        firma: 'Company',
        firma2: 'Company 2',
        street: 'Street',
        zip: 'Postcode',
        city: 'City',
        phone: 'Phone',
        mobile: 'Mobile',
        email: 'Email',
        fax: 'Fax',
        bgNumber: 'Company no.',
        payers: 'Responsible BG',
        vatNumber: 'VAT ID',
        taxNumber: 'Tax no.',
        costCenter: 'Cost centre',
        debKonto: 'Debtor account'
      }
    },
    filters: {
      status: 'Status',
      statusAll: 'all',
      statusGreen: 'Green',
      statusYellowRed: 'Yellow/Red',
      statusBlack: 'Black',
      course: 'Course'
    },
    colors: {
      black: 'Black',
      red: 'Red',
      yellow: 'Yellow',
      green: 'Green'
    },
    legend: {
      title: 'Legend',
      green: '0–12 months',
      yellow: '13–19 months',
      red: '20–24 months',
      black: '25 months and more'
    },
    candidates: {
      title: 'Participants',
      name: 'Name',
      course: 'Course',
      firstDate: 'first course day',
      lastDate: 'last course day',
      empty: 'No participants found',
      external: 'Registered via the company portal',
      selected: '{count} selected',
      letterTooltip: 'Reminder letter: {name} / Date: {date}'
    },
    letters: {
      title: 'Letter',
      slot: 'Letter {slot}',
      change: 'Change letter',
      changeTitle: 'Change letter {slot}',
      template: 'Letter template',
      save: 'Save',
      saveError: 'The letter could not be saved.'
    },
    freeText: 'Additional information',
    preview: {
      title: 'Preview',
      loading: 'Loading preview …',
      empty: 'No preview available',
      selectParticipants: 'Please select participants to show the preview.',
      page: 'Page {current} of {total}',
      error: 'The preview could not be loaded.'
    },
    dispatch: {
      refreshPreview: 'Refresh preview',
      letterToMe: 'Letter to me',
      notStoredHint: 'Documents are generated but not stored or linked anywhere.',
      filename: 'Marketing-letter.pdf',
      cancel: 'Cancel',
      error: 'The job could not be started.',
      mailToMe: {
        button: 'Mail to me',
        title: 'Send mail to me',
        confirm: 'The email with the letter "{letter}" to {addressee} ({count} participants) is sent to your own email address and not stored.',
        action: 'Send'
      },
      mail: {
        button: 'Send mail(s)',
        title: 'Send mail(s)',
        confirm: 'The letter "{letter}" is sent by email to {addressee} ({count} participants). The reminder letter is recorded for the participants.',
        action: 'Send'
      },
      print: {
        button: 'Print letter(s)',
        title: 'Print letter(s)',
        confirm: 'The letter "{letter}" to {addressee} is created as PDF ({count} participants). The reminder letter is recorded for the participants.',
        action: 'Print'
      }
    },
    messages: {
      loadError: 'The Marketing tool data could not be loaded.'
    }
  }
}
